import { HtmlNodeModel, HtmlNode } from '@logicflow/core';
// import { HtmlResize } from "@logicflow/extension";
import "../../../uml.css";
import $ from "jquery";
import { ElMessageBox as MessageBox } from "element-plus";
import img_pre from "../../../assets/title_pre.png";
import img_nor from "../../../assets/title_nor.png";
import { sendUpdate, add_Operation } from "../../../tools/send.js";
import { zhHansLanguage } from "../../../lang/zh-Hans.js";
import { zhHantLanguage } from "../../../lang/zh-Hant.js";
import { enLanguage } from "../../../lang/en.js";

class CardModel extends HtmlNodeModel {
  initNodeData(data) {
    super.initNodeData(data);
    this.text.editable = false; // 禁止节点文本编辑
    // 设置节点宽高和鼠标移动多少距离后开始缩放节点
    const width =
      data.properties.nodeSize && data.properties.nodeSize.width
        ? data.properties.nodeSize.width
        : 250;
    const height =
      data.properties.nodeSize && data.properties.nodeSize.height
        ? data.properties.nodeSize.height
        : 250;
    // const height = 250
    this.width = width;
    this.height = height;
    this.minWidth = 80;
    this.minHeight = 80;
    this.gridSize = 1;
    const unable_to_connect_with_oneself = {
      message:
        window.location.href.indexOf("cocorobo.cn") != -1
          ? zhHansLanguage.tip43
          : window.location.href.indexOf("cocorobo.hk") != -1
          ? zhHantLanguage.tip43
          : enLanguage.tip43,
      validate: (sourceNode, targetNode, sourceAnchor, targetAnchor) => {
        console.log(sourceAnchor, targetAnchor);
        return targetNode.id != sourceNode.id;
      },
    };
    this.sourceRules.push(unable_to_connect_with_oneself);
    const unable_to_connect_with_theme = {
      message:
        window.location.href.indexOf("cocorobo.cn") != -1
          ? zhHansLanguage.unable_to_connect_with_theme
          : window.location.href.indexOf("cocorobo.hk") != -1
          ? zhHantLanguage.unable_to_connect_with_theme
          : enLanguage.unable_to_connect_with_theme,
      validate: (sourceNode, targetNode, sourceAnchor, targetAnchor) => {
        console.log(sourceNode, sourceAnchor, targetAnchor);
        return targetNode.type != "icon-theme";
      },
    };
    this.sourceRules.push(unable_to_connect_with_theme);
    const unable_to_connect_with_other = {
      message:
        window.location.href.indexOf("cocorobo.cn") != -1
          ? zhHansLanguage.unable_to_connect_with_other
          : window.location.href.indexOf("cocorobo.hk") != -1
          ? zhHantLanguage.unable_to_connect_with_other
          : enLanguage.unable_to_connect_with_other,
      validate: (sourceNode, targetNode, sourceAnchor, targetAnchor) => {
        console.log(sourceAnchor, targetAnchor);
        let edges = this.graphModel.getNodeOutgoingEdge(sourceNode.id);
        let isConnect = false;
        for (let i = 0; i < edges.length; i++) {
          if (
            edges[i].sourceNodeId == sourceNode.id &&
            edges[i].targetNodeId == targetNode.id
          ) {
            isConnect = true;
            break;
          }
        }
        return isConnect == false;
      },
    };
    this.sourceRules.push(unable_to_connect_with_other);
    // 设置锚点
    // this.anchorsOffset = [
    //   [width / 2, 0],
    //   [0, height / 2],
    //   [-width / 2, 0],
    //   [0, -height / 2],
    // ]
  }
  setAttributes() {
    // if (this.properties.radio == 'videoList' && this.properties.videoList && this.properties.videoList.length != 0 && this.properties.styleRadio == "2" && this.properties.outerHeight) {
    //   this.height = this.properties.outerHeight
    // }
    // else if (this.properties.radio == 'videoList' && this.properties.videoList && this.properties.videoList.length != 0 && this.properties.styleRadio == "1" && this.properties.height) {
    //   this.height = this.properties.height
    // }
    if (
      (this.properties.iconRadio == true &&
        this.properties.nodeSize &&
        this.properties.nodeSize.height &&
        parseInt(this.properties.nodeSize.height) <= 80) ||
      (this.properties.iconRadio == true &&
        this.properties.nodeSize &&
        this.properties.nodeSize.width &&
        parseInt(this.properties.nodeSize.width) <= 80)
    ) {
      this.width = 80;
      this.height = 80;
    }
    if (
      (this.properties.iconRadio == false &&
        this.properties.nodeSize &&
        this.properties.nodeSize.height &&
        parseInt(this.properties.nodeSize.height) == 250) ||
      (this.properties.iconRadio == false &&
        this.properties.nodeSize &&
        this.properties.nodeSize.width &&
        parseInt(this.properties.nodeSize.width) == 250)
    ) {
      this.width = 250;
      this.height = 250;
    }
    // if(this.properties.height && this.properties.width) {
    //   this.width = this.properties.width
    //   this.height = this.properties.height
    // }
  }
  getData() {
    const data = super.getData();
    let properties = data.properties;
    properties = {
      ...properties,
      nodeSize: {
        width: this.width,
        height: this.height,
      }
    }
    return {
      ...super.getData(),
      properties: properties
    }
  }
  // getResizeOutlineStyle(){
  //   const style = super.getResizeOutlineStyle();
  //   style.stroke = "#007BFF";
  //   style.strokeWidth = 2
  //   style.strokeDasharray = "3,3"
  //   style.fill = "transparent"
  //   return style;
  // }
}
class CardNode extends HtmlNode {
  contentTitle(eleDom, textTips, lf, isShowDescribe) {
    const itemDom = document.createElement("div"); //增加提个DOM p标签，用于展示 自定义title
    itemDom.setAttribute("class", "robotHeaderBar-Value"); //添加class命名，用于设置自定义title样式
    // itemDom.style = "border: 1px solid #ffffff;left:" + (eleDom.getBoundingClientRect().width + 10) + "px;top:" + (eleDom.getBoundingClientRect().height - 40) + "px;";
    itemDom.style = "border: 1px solid #ffffff;left:104%;top:80%;";
    const div = document.createElement("div");
    div.style =
      "background: #FFFFFF;width:30px;height:30px;display: flex;flex-direction: row;align-items: center;justify-content: center;";

    const img = document.createElement("img");
    img.src = img_nor;
    div.appendChild(img);
    itemDom.appendChild(div);

    eleDom.parentNode.style = "overflow: visible;";
    // let itemDomShow = false; //用于判断是否添加了节点
    let itemClickDomShow = isShowDescribe;
    const p = document.createElement("p");
    // let conSetTimeout = null;
    // const setTime = 1000; //延迟1.5秒
    //鼠标移入事件
    // const eleMouseenter = function () {
    //   conSetTimeout = setTimeout(function () {
    //     //移入增加DOM节点 （自定义title）
    //     //eleDom表示，需要在哪个DOM下增加title
    //     // eleDom.appendChild(itemDom);
    //     // itemDomShow = true;
    //     // eleDom.parentNode.style= "overflow: visible;";
    //     p.textContent = textTips; //参数textTips 代表需要展示的自定义title文本
    //     p.style = "margin-left:10px;margin-right:10px;"
    //     itemDom.appendChild(p);
    //     img.src = img_pre;
    //     itemDomShow = true;
    //     // itemDom.style = "border: 1px solid #007BFF;left:" + (eleDom.getBoundingClientRect().width + 10) + "px;top:" + (eleDom.getBoundingClientRect().height - 40) + "px;";
    //     itemDom.style = "border: 1px solid #ffffff;left:104%;top:80%;";
    //     div.style = "background: #007BFF;width:30px;height:30px;display: flex;flex-direction: row;align-items: center;justify-content: center;border-bottom-left-radius: 6px;border-top-left-radius: 6px;border: 1px solid rgb(0, 123, 255);";
    //   }, setTime);
    // };
    //鼠标移出
    // const eleMouseleave = function () {
    //   //清除延时器
    //   clearTimeout(Number(conSetTimeout));
    //   if (itemDomShow && !itemClickDomShow) {
    //     //删除节点
    //     // eleDom.removeChild(itemDom);
    //     // itemDomShow = false;
    //     // eleDom.parentNode.style= "overflow: hidden;";
    //     itemDom.removeChild(p);
    //     itemDomShow = false;
    //     img.src = img_nor;
    //     itemDom.style = "border: 1px solid #ffffff;left:104%;top:80%;";
    //     // itemDom.style = "border: 1px solid #ffffff;left:" + (eleDom.getBoundingClientRect().width + 10) + "px;top:" + (eleDom.getBoundingClientRect().height - 40) + "px;";
    //     div.style = "background: #FFFFFF;width:30px;height:30px;display: flex;flex-direction: row;align-items: center;justify-content: center;";
    //   }
    // };
    // 点击后也设置为不显示自定义title
    // const eleClick = function (e) {
    //   if (itemClickDomShow) {
    //     itemDom.removeChild(p);
    //     itemClickDomShow = false;
    //     img.src = img_nor;
    //     // itemDom.style = "border: 1px solid #ffffff;left:" + (eleDom.getBoundingClientRect().width + 10) + "px;top:" + (eleDom.getBoundingClientRect().height - 40) + "px;";
    //     itemDom.style = "border: 1px solid #ffffff;left:104%;top:80%;";
    //     div.style = "background: #FFFFFF;width:30px;height:30px;display: flex;flex-direction: row;align-items: center;justify-content: center;";
    //     lf.graphModel.getNodeModelById(lf.model.id).setProperties({
    //       isShowDescribe: false
    //     });
    //     let nodes = []
    //     nodes.push(lf.graphModel.getNodeModelById(lf.model.id).getData())
    //     sendUpdate(nodes, [], "update", 0)
    //   } else {
    //     p.textContent = textTips; //参数textTips 代表需要展示的自定义title文本
    //     p.style = "margin-left:10px;margin-right:10px;"
    //     itemDom.appendChild(p);
    //     img.src = img_pre;
    //     itemClickDomShow = true;
    //     // itemDom.style = "border: 1px solid #007BFF;left:" + (eleDom.getBoundingClientRect().width + 10) + "px;top:" + (eleDom.getBoundingClientRect().height - 40) + "px;";
    //     itemDom.style = "border: 1px solid #ffffff;left:104%;top:80%;";
    //     div.style = "background: #007BFF;width:30px;height:30px;display: flex;flex-direction: row;align-items: center;justify-content: center;border-bottom-left-radius: 6px;border-top-left-radius: 6px;border: 1px solid rgb(0, 123, 255);";
    //     lf.graphModel.getNodeModelById(lf.model.id).setProperties({
    //       isShowDescribe: true
    //     });
    //     let nodes = []
    //     nodes.push(lf.graphModel.getNodeModelById(lf.model.id).getData())
    //     sendUpdate(nodes, [], "update", 0)
    //   }
    //   e.stopPropagation();
    // };

    // div.addEventListener("mouseenter", eleMouseenter);
    // div.addEventListener("mouseleave", eleMouseleave);
    // div.addEventListener("click", eleClick);
    div.title = textTips;

    if (itemClickDomShow) {
      p.textContent = textTips; //参数textTips 代表需要展示的自定义title文本
      p.style = "margin-left:10px;margin-right:10px;";
      itemDom.appendChild(p);
      img.src = img_pre;
      // itemDom.style = "border: 1px solid #007BFF;left:" + (eleDom.getBoundingClientRect().width + 10) + "px;top:" + (eleDom.getBoundingClientRect().height - 40) + "px;";
      itemDom.style = "border: 1px solid #ffffff;left:104%;top:80%;";
      div.style =
        "background: #007BFF;width:30px;height:30px;display: flex;flex-direction: row;align-items: center;justify-content: center;border-bottom-left-radius: 6px;border-top-left-radius: 6px;border: 1px solid rgb(0, 123, 255);";
    }

    eleDom.appendChild(itemDom);
  }
  addTransparent(id, checked) {
    if (document.getElementById("div_" + id)) {
      const div = document.getElementById("div_" + id);
      let itemDomShow = false; //用于判断是否添加了节点
      let conSetTimeout = null;
      const setTime = 100; //延迟1.5秒
      //鼠标移入事件
      const eleMouseenter = function () {
        conSetTimeout = setTimeout(function () {
          if (checked) {
            itemDomShow = true;
            div.style =
              "width:80px;height:80px;display: flex;justify-content: center;align-items: center;background: #dcdfe6;";
          }
        }, setTime);
      };
      //鼠标移出
      const eleMouseleave = function () {
        //清除延时器
        clearTimeout(Number(conSetTimeout));
        if (itemDomShow && checked) {
          itemDomShow = false;
          div.style =
            "width:80px;height:80px;display: flex;justify-content: center;align-items: center;background: none;";
        }
      };
      div.addEventListener("mouseenter", eleMouseenter);
      div.addEventListener("mouseleave", eleMouseleave);
    }
  }

  showComment(eleDom,properties,comments,likes,lf,id) {
    if(properties.isShowComment) {
      const itemDom = document.createElement("div"); //增加提个DOM p标签，用于展示 自定义title
      itemDom.setAttribute("class", "robotHeaderBar-Value"); //添加class命名，用于设置自定义title样式
      itemDom.style = "pointer-events: none;flex-direction: column;border: 1px solid #ffffff;left:104%;top:70%;width:300px;background: #f2f2f2;height: auto;padding: 10px 0;cursor: default;";
      eleDom.parentNode.style = "overflow: visible;";
      itemDom.addEventListener("click",function(e) {
        e.stopPropagation()
      })
      // 创建操作区
      let div = document.createElement("div");
      div.style =
        "color:#000000;padding:0 15px;display: flex;align-items: center;font-size: 18px;flex-wrap: wrap;width: calc(100% - 30px);";
      // 点赞区域
      let likeDiv = document.createElement("div");
      likeDiv.style = "display: flex;cursor: pointer;align-items: center;margin-right:15px;pointer-events: auto;";
      // 点赞或者取消点赞
      likeDiv.addEventListener("click", function(e) {
        if(likes.includes(properties.currentUserName)) {
          let index = 0;
          for(let i = 0;i < likes.length;i++) {
            if(likes[i] == properties.currentUserName) {
              index = i
            }
          }
          lf.model.properties.likeList.splice(index, 1);
          let nodes = [];
          let data = lf.graphModel.getElement(id).getData()
          data.properties.isShowComment = false
          nodes.push(data);
          let edges = [];
          sendUpdate(nodes, edges, "update", 0)
        }
        else {
          lf.model.properties.likeList.push(properties.currentUserName)
          let nodes = [];
          let data = lf.graphModel.getElement(id).getData()
          data.properties.isShowComment = false
          nodes.push(data);
          let edges = [];
          sendUpdate(nodes, edges, "update", 0)
        }
        e.stopPropagation()
      })
      let likeSvgDom = document.createElementNS('http://www.w3.org/2000/svg','svg');
      if(likes.includes(properties.currentUserName)) {
        likeSvgDom.setAttribute('class', 'icon')
        likeSvgDom.setAttribute('viewBox', '0 0 1024 1024')
        likeSvgDom.setAttribute('width','20');
        likeSvgDom.setAttribute('height','20');
        likeSvgDom.setAttribute('style','margin-right:5px;')
        let likePath = document.createElementNS('http://www.w3.org/2000/svg','path');
        likePath.setAttribute('d','M512 212c34.807-47.132 72.255-79.819 129-98 65.138-20.869 137.775-10.084 187 15 46.803 23.85 87.297 62.935 111 115 23.327 51.241 31.316 124.868 8 188-19.159 51.876-59.153 92.369-95 132-97.461 107.75-197.813 217.01-296 326-13.017 14.448-23.293 29.737-47 28-21.365-1.565-38.202-26.684-52-42-102.76-114.065-208.533-229.068-310-342-29.361-32.679-59.304-65.592-74-113-15.138-48.835-13.742-112.207 4-160 30.9-83.24 109.934-153.256 218-159 107.503-5.714 171.91 50.972 217 110z');
        likePath.setAttribute('fill','#d81e06');
        likeSvgDom.appendChild(likePath);
        likeDiv.appendChild(likeSvgDom);
        let pLikeText = document.createElement("p");
        pLikeText.setAttribute('style','margin:0 5px;');
        pLikeText.textContent = window.location.href.indexOf("cocorobo.cn") != -1 ? zhHansLanguage.cancel : window.location.href.indexOf("cocorobo.hk") != -1 ? zhHantLanguage.cancel : enLanguage.cancel;
        likeDiv.appendChild(pLikeText);
        div.appendChild(likeDiv);
      }
      else{
        likeSvgDom.setAttribute('class', 'icon')
        likeSvgDom.setAttribute('viewBox', '0 0 1024 1024')
        likeSvgDom.setAttribute('width','20');
        likeSvgDom.setAttribute('height','20');
        likeSvgDom.setAttribute('style','margin-right:5px;')
        let likePath = document.createElementNS('http://www.w3.org/2000/svg','path');
        likePath.setAttribute('d','M310.388364 99.165091 310.388364 99.165091c20.619636 0 41.378909 2.699636 61.579636 7.982545 39.354182 10.402909 76.520727 29.975273 110.475636 58.112l29.602909 24.552727 29.672727-24.459636c34.420364-28.346182 71.447273-47.941818 109.800727-58.135273 20.270545-5.236364 41.029818-7.866182 61.696-7.866182 25.297455 0 50.827636 3.956364 75.333818 11.613091 40.471273 13.149091 78.661818 36.212364 109.847273 66.117818 30.254545 30.021818 53.341091 67.118545 66.769455 107.240727l2.722909 7.959273c12.125091 41.565091 12.753455 82.920727 1.722182 123.392-11.008 41.704727-34.746182 82.408727-68.770909 117.922909l-2.234182 1.559273-2.839273 2.839273L512.139636 921.157818 126.464 536.203636c-35.770182-35.746909-60.672-77.428364-72.145455-120.925091-11.659636-42.728727-10.193455-86.900364 4.212364-130.932364 13.381818-39.819636 36.933818-77.032727 67.933091-107.403636 31.511273-30.580364 69.236364-53.341091 109.381818-65.954909C260.235636 103.144727 285.323636 99.165091 310.388364 99.165091M310.365091 52.619636c-29.090909 0-58.903273 4.445091-88.762182 14.056727-48.128 15.104-92.229818 42.589091-127.534545 76.869818-35.746909 35.025455-63.720727 78.615273-79.639273 125.998545-17.850182 54.434909-18.618182 108.125091-5.003636 157.998545C23.272727 480.186182 52.736 528.337455 93.579636 569.134545l390.609455 389.864727c7.912727 8.285091 18.059636 12.381091 28.136727 12.381091 9.821091 0 19.572364-3.909818 27.042909-11.636364l389.329455-388.840727 2.513455-1.768727c40.075636-40.797091 69.538909-88.948364 83.432727-141.614545 13.591273-49.896727 12.823273-103.563636-5.050182-157.998545l-0.279273 0c-15.872-47.383273-43.101091-90.717091-78.103273-125.486545-36.258909-34.792727-80.128-61.719273-128.256-77.358545-30.161455-9.402182-60.253091-13.870545-89.716364-13.870545-24.971636 0-49.501091 3.211636-73.309091 9.332364-46.382545 12.334545-89.227636 35.514182-127.767273 67.281455C473.832727 97.652364 430.498909 74.472727 383.860364 62.138182 360.168727 55.924364 335.522909 52.619636 310.365091 52.619636L310.365091 52.619636z');
        likePath.setAttribute('fill','#000000');
        likeSvgDom.appendChild(likePath);
        likeDiv.appendChild(likeSvgDom);
        let pLikeText = document.createElement("p");
        pLikeText.setAttribute('style','margin:0 5px;');
        pLikeText.textContent = window.location.href.indexOf("cocorobo.cn") != -1 ? zhHansLanguage.zan : window.location.href.indexOf("cocorobo.hk") != -1 ? zhHantLanguage.zan : enLanguage.zan;
        likeDiv.appendChild(pLikeText);
        div.appendChild(likeDiv);
      }
      // 评论区域
      let commentDiv = document.createElement("div");
      commentDiv.style = "display: flex;cursor: pointer;align-items: center;pointer-events: auto;";
      let isShowWriteComment = false;
      let commentInputDiv = null;
      commentDiv.addEventListener("click", function(e) {
        isShowWriteComment = !isShowWriteComment;
        if(isShowWriteComment) {
          commentInputDiv = document.createElement("div");
          commentInputDiv.style = "color:#000000;margin-top: 15px;padding:0 15px;display: flex;align-items: center;font-size: 18px;flex-wrap: wrap;width: calc(100% - 30px);";
          let textarea = document.createElement("textarea");
          textarea.placeholder = window.location.href.indexOf("cocorobo.cn") != -1 ? zhHansLanguage.searchImagesDesc : window.location.href.indexOf("cocorobo.hk") != -1 ? zhHantLanguage.searchImagesDesc : enLanguage.searchImagesDesc; // 设置输入框占位符文本
          textarea.setAttribute("rows","3");
          textarea.className = "el-textarea__inner";
          textarea.style = "padding:10px;pointer-events: auto;overflow-y:hidden;height:auto;width: 74%;margin-right: 10px;"
          textarea.addEventListener("mousedown",function(e) {
            e.stopPropagation();
          })
          textarea.addEventListener("click",function(e) {
            textarea.className = "el-textarea__inner is-focus";
            textarea.style = "padding:10px;pointer-events: auto;overflow-y:hidden;height:auto;width: 74%;margin-right: 10px;box-shadow: 0 0 0 1px #409eff inset;"
            e.stopPropagation();
          })
          textarea.addEventListener('input', function () {
            this.style.height = 'auto';
            this.style.height = (this.scrollHeight + 2) + 'px';
          });
          commentInputDiv.appendChild(textarea); // 将输入框添加到页面上
          let button = document.createElement("button");
          button.type = "button";
          button.style = "--el-button-size: 28px;padding: 7px 15px;pointer-events: auto;";
          button.className = "el-button el-button--primary el-button--small run";
          button.textContent = window.location.href.indexOf("cocorobo.cn") != -1 ? zhHansLanguage.sendButton : window.location.href.indexOf("cocorobo.hk") != -1 ? zhHantLanguage.sendButton : enLanguage.sendButton;
          button.addEventListener("click",function(e) {
            lf.model.properties.commentList.push({ username: properties.currentUserName, text: textarea.value })
            let nodes = [];
            let data = lf.graphModel.getElement(id).getData()
            data.properties.isShowComment = false
            nodes.push(data);
            let edges = [];
            sendUpdate(nodes, edges, "update", 0)
            itemDom.removeChild(commentInputDiv)
            e.stopPropagation();
          })
          commentInputDiv.appendChild(button)
          itemDom.appendChild(commentInputDiv);
        }
        else {
          itemDom.removeChild(commentInputDiv);
        }
        e.stopPropagation()
      })
      let commentSvgDom = document.createElementNS('http://www.w3.org/2000/svg','svg');
      commentSvgDom.setAttribute('class', 'icon')
      commentSvgDom.setAttribute('viewBox', '0 0 1024 1024')
      commentSvgDom.setAttribute('width','20');
      commentSvgDom.setAttribute('height','20');
      commentSvgDom.setAttribute('style','margin-right:5px;')
      let commentPath = document.createElementNS('http://www.w3.org/2000/svg','path');
      commentPath.setAttribute('d','M330.744242 885.372121l194.779798-129.861818 16.665859-11.106263h383.844848c36.486465 0 66.19798-29.659798 66.19798-66.146262v-529.19596c0-36.434747-29.711515-66.107475-66.19798-66.107475H132.305455c-36.486465 0-66.146263 29.659798-66.146263 66.107475v529.19596c0 36.486465 29.659798 66.146263 66.146263 66.146262h198.438787v140.968081m-66.146262 123.578182V810.550303H132.305455c-73.024646 0-132.305455-59.216162-132.305455-132.292525v-529.19596C0 76.024242 59.267879 16.808081 132.305455 16.808081h793.742222c73.076364 0 132.357172 59.216162 132.357171 132.240808v529.195959c0 73.076364-59.267879 132.292525-132.357171 132.292526h-363.830303L264.59798 1008.950303z m0 0');
      commentPath.setAttribute('fill','#000000');
      commentSvgDom.appendChild(commentPath);
      commentDiv.appendChild(commentSvgDom);
      let pCommentText = document.createElement("p");
      pCommentText.setAttribute('style','margin:0 5px;');
      pCommentText.textContent = window.location.href.indexOf("cocorobo.cn") != -1 ? zhHansLanguage.comment : window.location.href.indexOf("cocorobo.hk") != -1 ? zhHantLanguage.comment : enLanguage.comment;
      commentDiv.appendChild(pCommentText);
      div.appendChild(commentDiv);
      itemDom.appendChild(div);

      // 点赞列表
      if (likes.length != 0) {
        let like = document.createElement("div");
        like.style =
          "color:#3f81c1;padding:0 15px;display: flex;align-items: center;font-size: 15px;margin-top: 10px;flex-wrap: wrap;width: calc(100% - 30px);";
        let svgDom = document.createElementNS('http://www.w3.org/2000/svg','svg');
        svgDom.setAttribute('class', 'icon')
        svgDom.setAttribute('viewBox', '0 0 1024 1024')
        svgDom.setAttribute('width','25');
        svgDom.setAttribute('height','25');
        svgDom.setAttribute('style','margin-right:10px;')
        let path = document.createElementNS('http://www.w3.org/2000/svg','path');
        path.setAttribute('d','M480.2 921.5c-11.2 0-22.4-2.8-32.4-8.6C342.5 852.4 34.1 605.1 25.3 385.5c-3-76.7 24.4-149.4 77.4-204.5 50.5-52.6 120-82.8 190.6-82.8 69.9 0 136 28.6 186.3 80.6 0.5 0.6 1.2 0.7 1.7 0.7s1.2-0.1 1.7-0.7c50.2-51.9 116.4-80.6 186.2-80.6 77.7 0 155.4 36 208 96.2 48.1 55.1 69.4 123.6 59.9 192.8-30.6 223.6-303 454.1-422.5 524.9-10.6 6.3-22.5 9.4-34.4 9.4zM293.3 133.1c-61.1 0-121.5 26.3-165.5 72.1-46.4 48.2-70.4 111.8-67.7 179 7.7 193.8 289 431.9 405.1 498.6 9.6 5.5 21.7 5.3 31.7-0.6 128-75.8 378.5-300.2 405.8-499.6 8.1-59-10.3-117.7-51.7-165.1-46-52.8-114-84.3-181.7-84.3-60.3 0-117.6 24.8-161.2 69.9-7 7.2-16.7 11.3-26.7 11.3-10.2 0-19.7-4-26.7-11.3-43.8-45.2-101-70-161.4-70z');
        path.setAttribute('fill','#3f81c1');
        svgDom.appendChild(path);
        like.appendChild(svgDom);
        for(let i = 0;i < likes.length;i++) {
          let p = document.createElement("p");
          p.setAttribute('style','margin:0 5px;');
          if (i != likes.length - 1) {
            p.textContent = likes[i] + ", ";
          }
          else {
            p.textContent = likes[i];
          }
          like.appendChild(p);
        }
        itemDom.appendChild(like);
      }
      
      // 评论列表
      if (comments.length != 0) {
        let comment = document.createElement("div");
        comment.style =
          "padding:0 15px;display: flex;flex-direction: column;font-size: 15px;margin-top: 10px;flex-wrap: wrap;width: calc(100% - 30px);";
        for(let i = 0;i < comments.length;i++) {
          let p = document.createElement("p");
          p.setAttribute('style','margin:0 5px 5px 0;overflow: hidden;white-space: normal;overflow-wrap: break-word;');
          p.textContent = comments[i].username + ": " + comments[i].text
          comment.appendChild(p);
        }
        itemDom.appendChild(comment);
      }
      eleDom.appendChild(itemDom);
    }
  }

  setHtml(rootEl) {
    const { id, properties } = this.props.model;
    properties.isShowComment = properties.isShowComment ? properties.isShowComment : false
    properties.likeList = properties.likeList ? properties.likeList : []
    properties.commentList = properties.commentList ? properties.commentList : []
    var color =
      properties.titleColor && properties.titleColor != ""
        ? properties.titleColor
        : "#6266BC";
    let cardTitle =
      window.location.href.indexOf("cocorobo.cn") != -1
        ? zhHansLanguage.card
        : window.location.href.indexOf("cocorobo.hk") != -1
        ? zhHantLanguage.card
        : enLanguage.card;
    const el = document.createElement("div");
    el.className = "uml-wrapper";
    // el.title = properties.describe ? properties.describe : ''
    // el.style = "border: 1px solid " + color + ';';
    var html = ``;
    if (
      (properties.iconRadio == true &&
        properties.nodeSize &&
        properties.nodeSize.height &&
        parseInt(properties.nodeSize.height) <= 80) ||
      (properties.iconRadio == true &&
        properties.nodeSize &&
        properties.nodeSize.width &&
        parseInt(properties.nodeSize.width) <= 80)
    ) {
      el.style =
        "width:80px;height:80px;display: flex;justify-content: center;align-items: center;background:none";
      el.id = "div_" + id;
      if (
        properties.iconList &&
        properties.iconList.length != 0 &&
        !properties.checked
      ) {
        html = `<div style="width:60px;height:60px;background:url(${properties.iconList[0].url}) no-repeat;background-size:cover;">
        </div>
        `;
      } else if (
        properties.iconList &&
        properties.iconList.length != 0 &&
        properties.checked
      ) {
        html = `<div style="width:60px;height:60px;">
        </div>
        `;
      }
      el.innerHTML = html;
      // 需要先把之前渲染的子节点清除掉。
      rootEl.innerHTML = "";
      rootEl.appendChild(el);
      this.addTransparent(id, properties.checked ? properties.checked : false);

      if (
        (properties.iconRadio == true &&
          properties.nodeSize &&
          properties.nodeSize.height &&
          parseInt(properties.nodeSize.height) <= 80) ||
        (properties.iconRadio == true &&
          properties.nodeSize &&
          properties.nodeSize.width &&
          parseInt(properties.nodeSize.width) <= 80)
      ) {
        if (
          properties.iconList &&
          properties.iconList.length != 0 &&
          !properties.checked
        ) {
          $("#div_" + id)
            .parent()
            .css("background", "none");
          $("#div_" + id)
            .parent()
            .css("box-shadow", "none");
        } else if (
          properties.iconList &&
          properties.iconList.length != 0 &&
          properties.checked
        ) {
          $("#div_" + id)
            .parent()
            .css("background", "none");
          $("#div_" + id)
            .parent()
            .css("box-shadow", "none");
        }
        // else {
        //   $("#div_" + id).parent().css("background", "none")
        //   $("#div_" + id).parent().css("box-shadow", "none")
        // }
      }
    } else {
      // if (properties.isShowTitle) {
      //   el.style = "box-shadow:none;"
      // }
      html = `
      <div class="is_show_user" style="${
        properties.is_show_user ? "display:flex;" : "display:none;"
      }">
        <i class="el-icon" style="font-size: 18px;color:#58aba2;width: 18px;height: 27px;" >
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024" ><path fill="currentColor" d="M628.736 528.896A416 416 0 0 1 928 928H96a415.872 415.872 0 0 1 299.264-399.104L512 704zM720 304a208 208 0 1 1-416 0 208 208 0 0 1 416 0"></path></svg>
        </i>
        <div class="is_show_user_name">${properties.user_name}</div>
        <i class="el-icon" style="font-size: 16px;width: 16px;height: 27px;"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024" ><path fill="currentColor" d="m199.04 672.64 193.984 112 224-387.968-193.92-112-224 388.032zm-23.872 60.16 32.896 148.288 144.896-45.696zM455.04 229.248l193.92 112 56.704-98.112-193.984-112-56.64 98.112zM104.32 708.8l384-665.024 304.768 175.936L409.152 884.8h.064l-248.448 78.336zm384 254.272v-64h448v64h-448z"></path></svg></i>
        <div class="apostrophe"></div>
      </div>
      <div style="overflow: hidden;">
        <div class="uml-head" style="background-color:${color};${
        !properties.isShowTitle ? "display:block;" : "display:none;"
      }">${properties.title ? properties.title : cardTitle}</div>
        <i id="${id}" title="${ window.location.href.indexOf("cocorobo.cn") != -1 ? zhHansLanguage.deleteGraps : window.location.href.indexOf("cocorobo.hk") != -1 ? zhHantLanguage.deleteGraps : enLanguage.deleteGraps }" class="el-icon closeImg" style="${
          properties.isShowDelete ? "display:block;font-size: 20px;" : "display:none;font-size: 20px;"
        }"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024" ><path fill="currentColor" d="m466.752 512-90.496-90.496a32 32 0 0 1 45.248-45.248L512 466.752l90.496-90.496a32 32 0 1 1 45.248 45.248L557.248 512l90.496 90.496a32 32 0 1 1-45.248 45.248L512 557.248l-90.496 90.496a32 32 0 0 1-45.248-45.248z"></path><path fill="currentColor" d="M512 896a384 384 0 1 0 0-768 384 384 0 0 0 0 768m0 64a448 448 0 1 1 0-896 448 448 0 0 1 0 896"></path></svg>
        </i>
        <i id="comment_${id}" title="${ window.location.href.indexOf("cocorobo.cn") != -1 ? zhHansLanguage.comment : window.location.href.indexOf("cocorobo.hk") != -1 ? zhHantLanguage.comment : enLanguage.comment }" class="el-icon closeImg" style="${
          properties.isShowDelete ? "display:block;font-size: 17px;right: 30px;top: 5px;" : "display:none;font-size: 17px;right: 30px;top: 5px;"
        }"><svg t="1728889233368" class="icon" viewBox="0 0 1025 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="11716" width="20" height="20"><path d="M512.032 64c247.04 0 448 200.96 448 448s-200.96 448-448 448C264.928 960 64 759.04 64 512S265.056 64 512.032 64M512.032 0C229.184 0 0 229.216 0 512s229.184 512 512.064 512c282.752 0 512-229.216 512-512S794.816 0 512.032 0L512.032 0z" fill="currentColor" p-id="11717"></path><path d="M224 512m-80 0a2.5 2.5 0 1 0 160 0 2.5 2.5 0 1 0-160 0Z" fill="currentColor" p-id="11718"></path><path d="M512.032 512m-80 0a2.5 2.5 0 1 0 160 0 2.5 2.5 0 1 0-160 0Z" fill="currentColor" p-id="11719"></path><path d="M800.064 512m-80 0a2.5 2.5 0 1 0 160 0 2.5 2.5 0 1 0-160 0Z" fill="currentColor" p-id="11720"></path></svg>
        </i>
        <div class="uml-body">
          <div></div>
        </div>
      </div>
      `;
      // if (properties.radio == 'icon' && properties.iconList && properties.iconList.length != 0 && !properties.checked) {
      //   el.style = 'width:80px;height:80px;display: flex;justify-content: center;align-items: center;background:none';
      //   el.id = "div_" + id;
      //   html = `<div style="width:60px;height:60px;background:url(${properties.iconList[0].url}) no-repeat;background-size:cover;">
      //   </div>
      //   `
      // }
      // if (properties.radio == 'icon' && properties.iconList && properties.iconList.length != 0 && properties.checked) {
      //   html = `<div style="width:60px;height:60px;">
      //   </div>
      //   `
      // }
      if (
        properties.radio == "content" &&
        properties.content &&
        properties.content != ""
      ) {
        // let fontsize = $('.uml-body').css('font-size');
        // var len = properties.contentLength;
        // // console.log(len)
        // if (0 < len && len == 1) {
        //   fontsize = "160px";
        // } else if (1 < len && len <= 3) {
        //   fontsize = "80px";
        // } else if (3 < len && len <= 5) {
        //   fontsize = "40px";
        // } else if (5 < len && len <= 7) {
        //   fontsize = "20px";
        // } else if (7 < len && len <= 9) {
        //   fontsize = "12px";
        // }
        // else if(30 < properties.content.length && properties.content.length <= 40) {
        //   fontsize = "14px";
        // }
        // else {
        //   fontsize = "12px";
        // }
        el.id = "content-" + id;
        html = `
        <div class="is_show_user" style="${
          properties.is_show_user ? "display:flex;" : "display:none;"
        }">
          <i class="el-icon" style="font-size: 18px;color:#58aba2;width: 18px;height: 27px;" >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024" ><path fill="currentColor" d="M628.736 528.896A416 416 0 0 1 928 928H96a415.872 415.872 0 0 1 299.264-399.104L512 704zM720 304a208 208 0 1 1-416 0 208 208 0 0 1 416 0"></path></svg>
          </i>
          <div class="is_show_user_name">${properties.user_name}</div>
          <i class="el-icon" style="font-size: 16px;width: 16px;height: 27px;"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024" ><path fill="currentColor" d="m199.04 672.64 193.984 112 224-387.968-193.92-112-224 388.032zm-23.872 60.16 32.896 148.288 144.896-45.696zM455.04 229.248l193.92 112 56.704-98.112-193.984-112-56.64 98.112zM104.32 708.8l384-665.024 304.768 175.936L409.152 884.8h.064l-248.448 78.336zm384 254.272v-64h448v64h-448z"></path></svg></i>
          <div class="apostrophe"></div>
        </div>
        <div style="height:100%;overflow: hidden;" class="regular_card" >
          <div class="uml-head" style="background-color:${color};${
          !properties.isShowTitle ? "display:block;" : "display:none;"
        }">${properties.title ? properties.title : cardTitle}</div>
          <i id="${id}" title="${ window.location.href.indexOf("cocorobo.cn") != -1 ? zhHansLanguage.deleteGraps : window.location.href.indexOf("cocorobo.hk") != -1 ? zhHantLanguage.deleteGraps : enLanguage.deleteGraps }" class="${
            !properties.isShowTitle
              ? "el-icon closeImg"
              : "el-icon closeImgTheme"
            }" style="${
            properties.isShowDelete ? "display:block;font-size: 20px;" : "display:none;font-size: 20px;"
          }"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024" ><path fill="currentColor" d="m466.752 512-90.496-90.496a32 32 0 0 1 45.248-45.248L512 466.752l90.496-90.496a32 32 0 1 1 45.248 45.248L557.248 512l90.496 90.496a32 32 0 1 1-45.248 45.248L512 557.248l-90.496 90.496a32 32 0 0 1-45.248-45.248z"></path><path fill="currentColor" d="M512 896a384 384 0 1 0 0-768 384 384 0 0 0 0 768m0 64a448 448 0 1 1 0-896 448 448 0 0 1 0 896"></path></svg>
          </i>
          <i id="comment_${id}" title="${ window.location.href.indexOf("cocorobo.cn") != -1 ? zhHansLanguage.comment : window.location.href.indexOf("cocorobo.hk") != -1 ? zhHantLanguage.comment : enLanguage.comment }" class="el-icon closeImg" style="${
            properties.isShowDelete ? "display:block;font-size: 17px;right: 30px;top: 5px;" : "display:none;font-size: 17px;right: 30px;top: 5px;"
          }"><svg t="1728889233368" class="icon" viewBox="0 0 1025 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="11716" width="20" height="20"><path d="M512.032 64c247.04 0 448 200.96 448 448s-200.96 448-448 448C264.928 960 64 759.04 64 512S265.056 64 512.032 64M512.032 0C229.184 0 0 229.216 0 512s229.184 512 512.064 512c282.752 0 512-229.216 512-512S794.816 0 512.032 0L512.032 0z" fill="currentColor" p-id="11717"></path><path d="M224 512m-80 0a2.5 2.5 0 1 0 160 0 2.5 2.5 0 1 0-160 0Z" fill="currentColor" p-id="11718"></path><path d="M512.032 512m-80 0a2.5 2.5 0 1 0 160 0 2.5 2.5 0 1 0-160 0Z" fill="currentColor" p-id="11719"></path><path d="M800.064 512m-80 0a2.5 2.5 0 1 0 160 0 2.5 2.5 0 1 0-160 0Z" fill="currentColor" p-id="11720"></path></svg>
          </i>
          <div id="content_${id}" style="height:${
          !properties.isShowTitle ? "calc(100% - 30px)" : "calc(100%)"
        };overflow-y:auto;word-break: break-all;word-wrap: break-word;color: var(--font-icon-gy-2-secondary, rgba(0, 0, 0, 0.60));font-family: SimSun;font-size: 14px;font-style: normal;font-weight: 400;line-height: 22px;padding:8px 16px;">
            ${properties.content}
          </div>
        </div>
        `;
      }
      if (
        properties.radio == "iframeUrl" &&
        properties.iframeUrl &&
        properties.iframeUrl != "" &&
        !properties.isShowTitle
      ) {
        el.id = "iframeUrl-" + id;
        html = `
        <div class="is_show_user" style="${
          properties.is_show_user ? "display:flex;" : "display:none;"
        }">
        <i class="el-icon" style="font-size: 18px;color:#58aba2;width: 18px;height: 27px;" >
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024" ><path fill="currentColor" d="M628.736 528.896A416 416 0 0 1 928 928H96a415.872 415.872 0 0 1 299.264-399.104L512 704zM720 304a208 208 0 1 1-416 0 208 208 0 0 1 416 0"></path></svg>
        </i>
        <div class="is_show_user_name">${properties.user_name}</div>
        <i class="el-icon" style="font-size: 16px;width: 16px;height: 27px;"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024" ><path fill="currentColor" d="m199.04 672.64 193.984 112 224-387.968-193.92-112-224 388.032zm-23.872 60.16 32.896 148.288 144.896-45.696zM455.04 229.248l193.92 112 56.704-98.112-193.984-112-56.64 98.112zM104.32 708.8l384-665.024 304.768 175.936L409.152 884.8h.064l-248.448 78.336zm384 254.272v-64h448v64h-448z"></path></svg></i>
        <div class="apostrophe"></div>
      </div>
        <div style="height:100%;overflow: hidden;">
          <div class="uml-head" style="background-color:${color};${
          !properties.isShowTitle ? "display:block;" : "display:none;"
        }">${properties.title ? properties.title : cardTitle}</div>
          <i id="${id}" title="${ window.location.href.indexOf("cocorobo.cn") != -1 ? zhHansLanguage.deleteGraps : window.location.href.indexOf("cocorobo.hk") != -1 ? zhHantLanguage.deleteGraps : enLanguage.deleteGraps }" class="${
            !properties.isShowTitle
              ? "el-icon closeImg"
              : "el-icon closeImgTheme"
            }" style="${
            properties.isShowDelete ? "display:block;font-size: 20px;" : "display:none;font-size: 20px;"
          }"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024" ><path fill="currentColor" d="m466.752 512-90.496-90.496a32 32 0 0 1 45.248-45.248L512 466.752l90.496-90.496a32 32 0 1 1 45.248 45.248L557.248 512l90.496 90.496a32 32 0 1 1-45.248 45.248L512 557.248l-90.496 90.496a32 32 0 0 1-45.248-45.248z"></path><path fill="currentColor" d="M512 896a384 384 0 1 0 0-768 384 384 0 0 0 0 768m0 64a448 448 0 1 1 0-896 448 448 0 0 1 0 896"></path></svg>
          </i>
          <i id="comment_${id}" title="${ window.location.href.indexOf("cocorobo.cn") != -1 ? zhHansLanguage.comment : window.location.href.indexOf("cocorobo.hk") != -1 ? zhHantLanguage.comment : enLanguage.comment }" class="el-icon closeImg" style="${
            properties.isShowDelete ? "display:block;font-size: 17px;right: 30px;top: 5px;" : "display:none;font-size: 17px;right: 30px;top: 5px;"
          }"><svg t="1728889233368" class="icon" viewBox="0 0 1025 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="11716" width="20" height="20"><path d="M512.032 64c247.04 0 448 200.96 448 448s-200.96 448-448 448C264.928 960 64 759.04 64 512S265.056 64 512.032 64M512.032 0C229.184 0 0 229.216 0 512s229.184 512 512.064 512c282.752 0 512-229.216 512-512S794.816 0 512.032 0L512.032 0z" fill="currentColor" p-id="11717"></path><path d="M224 512m-80 0a2.5 2.5 0 1 0 160 0 2.5 2.5 0 1 0-160 0Z" fill="currentColor" p-id="11718"></path><path d="M512.032 512m-80 0a2.5 2.5 0 1 0 160 0 2.5 2.5 0 1 0-160 0Z" fill="currentColor" p-id="11719"></path><path d="M800.064 512m-80 0a2.5 2.5 0 1 0 160 0 2.5 2.5 0 1 0-160 0Z" fill="currentColor" p-id="11720"></path></svg>
          </i>
          <div class="uml-body" style="height:${
            !properties.isShowTitle ? "calc(100% - 30px)" : "calc(100%)"
          };width: 100%;padding:0;border-top:none;border-bottom-left-radius: 10px;border-bottom-right-radius: 10px;">
            <div id="iframeUrl_${id}" style="width: 100%;height:100%;">
              <iframe src=${
                properties.iframeUrl.indexOf("https://") != -1 ||
                properties.iframeUrl.indexOf("http://") != -1
                  ? properties.iframeUrl
                  : "//" + properties.iframeUrl
              } style="position: absolute;transform: scale(.5, .5) translate(-47%, -50%);width: 189%;height:171%;top: ${
          !properties.is_show_user ? "34px" : "62px"
        };left: 0;" frameborder="no" border="0" sandbox="allow-forms allow-scripts allow-same-origin"></iframe></div>
            </div>
        </div>
        `;
      }
      if (
        properties.radio == "iframeUrl" &&
        properties.iframeUrl &&
        properties.iframeUrl != "" &&
        properties.isShowTitle
      ) {
        el.id = "iframeUrl-" + id;
        html = `
        <div class="is_show_user" style="${
          properties.is_show_user ? "display:flex;" : "display:none;"
        }">
        <i class="el-icon" style="font-size: 18px;color:#58aba2;width: 18px;height: 27px;" >
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024" ><path fill="currentColor" d="M628.736 528.896A416 416 0 0 1 928 928H96a415.872 415.872 0 0 1 299.264-399.104L512 704zM720 304a208 208 0 1 1-416 0 208 208 0 0 1 416 0"></path></svg>
        </i>
        <div class="is_show_user_name">${properties.user_name}</div>
        <i class="el-icon" style="font-size: 16px;width: 16px;height: 27px;"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024" ><path fill="currentColor" d="m199.04 672.64 193.984 112 224-387.968-193.92-112-224 388.032zm-23.872 60.16 32.896 148.288 144.896-45.696zM455.04 229.248l193.92 112 56.704-98.112-193.984-112-56.64 98.112zM104.32 708.8l384-665.024 304.768 175.936L409.152 884.8h.064l-248.448 78.336zm384 254.272v-64h448v64h-448z"></path></svg></i>
        <div class="apostrophe"></div>
      </div>
        <div style="height:100%;overflow: hidden;">
          <div class="uml-head" style="background-color:${color};${
          !properties.isShowTitle ? "display:block;" : "display:none;"
        }">${properties.title ? properties.title : cardTitle}</div>
          <i id="${id}" title="${ window.location.href.indexOf("cocorobo.cn") != -1 ? zhHansLanguage.deleteGraps : window.location.href.indexOf("cocorobo.hk") != -1 ? zhHantLanguage.deleteGraps : enLanguage.deleteGraps }" class="${
            !properties.isShowTitle
              ? "el-icon closeImg"
              : "el-icon closeImgTheme"
            }" style="${
            properties.isShowDelete ? "display:block;font-size: 20px;" : "display:none;font-size: 20px;"
          }"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024" ><path fill="currentColor" d="m466.752 512-90.496-90.496a32 32 0 0 1 45.248-45.248L512 466.752l90.496-90.496a32 32 0 1 1 45.248 45.248L557.248 512l90.496 90.496a32 32 0 1 1-45.248 45.248L512 557.248l-90.496 90.496a32 32 0 0 1-45.248-45.248z"></path><path fill="currentColor" d="M512 896a384 384 0 1 0 0-768 384 384 0 0 0 0 768m0 64a448 448 0 1 1 0-896 448 448 0 0 1 0 896"></path></svg>
          </i>
          <i id="comment_${id}" title="${ window.location.href.indexOf("cocorobo.cn") != -1 ? zhHansLanguage.comment : window.location.href.indexOf("cocorobo.hk") != -1 ? zhHantLanguage.comment : enLanguage.comment }" class="el-icon closeImg" style="${
            properties.isShowDelete ? "display:block;font-size: 17px;right: 30px;top: 5px;" : "display:none;font-size: 17px;right: 30px;top: 5px;"
          }"><svg t="1728889233368" class="icon" viewBox="0 0 1025 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="11716" width="20" height="20"><path d="M512.032 64c247.04 0 448 200.96 448 448s-200.96 448-448 448C264.928 960 64 759.04 64 512S265.056 64 512.032 64M512.032 0C229.184 0 0 229.216 0 512s229.184 512 512.064 512c282.752 0 512-229.216 512-512S794.816 0 512.032 0L512.032 0z" fill="currentColor" p-id="11717"></path><path d="M224 512m-80 0a2.5 2.5 0 1 0 160 0 2.5 2.5 0 1 0-160 0Z" fill="currentColor" p-id="11718"></path><path d="M512.032 512m-80 0a2.5 2.5 0 1 0 160 0 2.5 2.5 0 1 0-160 0Z" fill="currentColor" p-id="11719"></path><path d="M800.064 512m-80 0a2.5 2.5 0 1 0 160 0 2.5 2.5 0 1 0-160 0Z" fill="currentColor" p-id="11720"></path></svg>
          </i>
          <div class="uml-body" style="height:${
            !properties.isShowTitle ? "calc(100% - 30px)" : "calc(100%)"
          };width: 100%;padding:0;border-top:none;border-bottom-left-radius: 10px;border-bottom-right-radius: 10px;">
            <div id="iframeUrl_${id}" style="width: 100%;height:100%;">
              <iframe src=${
                properties.iframeUrl.indexOf("https://") != -1 ||
                properties.iframeUrl.indexOf("http://") != -1
                  ? properties.iframeUrl
                  : "//" + properties.iframeUrl
              } style="position: absolute;transform: scale(.5, .5) translate(-47%, -50%);width: 189%;height:171%;top: ${
          !properties.is_show_user ? "23px" : "36.5px"
        };left: 0;" frameborder="no" border="0" sandbox="allow-forms allow-scripts allow-same-origin"></iframe></div>
            </div>
        </div>
        `;
      }
      if (
        properties.radio == "embedCode" &&
        properties.embedCode &&
        properties.embedCode != ""
      ) {
        el.id = "embedCode-" + id;
        html = `
        <div class="is_show_user" style="${
          properties.is_show_user ? "display:flex;" : "display:none;"
        }">
        <i class="el-icon" style="font-size: 18px;color:#58aba2;width: 18px;height: 27px;" >
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024" ><path fill="currentColor" d="M628.736 528.896A416 416 0 0 1 928 928H96a415.872 415.872 0 0 1 299.264-399.104L512 704zM720 304a208 208 0 1 1-416 0 208 208 0 0 1 416 0"></path></svg>
        </i>
        <div class="is_show_user_name">${properties.user_name}</div>
        <i class="el-icon" style="font-size: 16px;width: 16px;height: 27px;"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024" ><path fill="currentColor" d="m199.04 672.64 193.984 112 224-387.968-193.92-112-224 388.032zm-23.872 60.16 32.896 148.288 144.896-45.696zM455.04 229.248l193.92 112 56.704-98.112-193.984-112-56.64 98.112zM104.32 708.8l384-665.024 304.768 175.936L409.152 884.8h.064l-248.448 78.336zm384 254.272v-64h448v64h-448z"></path></svg></i>
        <div class="apostrophe"></div>
      </div>
        <div style="height:100%;overflow: hidden;">
          <div class="uml-head" style="background-color:${color};${
          !properties.isShowTitle ? "display:block;" : "display:none;"
        }">${properties.title ? properties.title : cardTitle}</div>
          <i id="${id}" title="${ window.location.href.indexOf("cocorobo.cn") != -1 ? zhHansLanguage.deleteGraps : window.location.href.indexOf("cocorobo.hk") != -1 ? zhHantLanguage.deleteGraps : enLanguage.deleteGraps }" class="${
            !properties.isShowTitle
              ? "el-icon closeImg"
              : "el-icon closeImgTheme"
            }" style="${
            properties.isShowDelete ? "display:block;font-size: 20px;" : "display:none;font-size: 20px;"
          }"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024" ><path fill="currentColor" d="m466.752 512-90.496-90.496a32 32 0 0 1 45.248-45.248L512 466.752l90.496-90.496a32 32 0 1 1 45.248 45.248L557.248 512l90.496 90.496a32 32 0 1 1-45.248 45.248L512 557.248l-90.496 90.496a32 32 0 0 1-45.248-45.248z"></path><path fill="currentColor" d="M512 896a384 384 0 1 0 0-768 384 384 0 0 0 0 768m0 64a448 448 0 1 1 0-896 448 448 0 0 1 0 896"></path></svg>
          </i>
          <i id="comment_${id}" title="${ window.location.href.indexOf("cocorobo.cn") != -1 ? zhHansLanguage.comment : window.location.href.indexOf("cocorobo.hk") != -1 ? zhHantLanguage.comment : enLanguage.comment }" class="el-icon closeImg" style="${
            properties.isShowDelete ? "display:block;font-size: 17px;right: 30px;top: 5px;" : "display:none;font-size: 17px;right: 30px;top: 5px;"
          }"><svg t="1728889233368" class="icon" viewBox="0 0 1025 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="11716" width="20" height="20"><path d="M512.032 64c247.04 0 448 200.96 448 448s-200.96 448-448 448C264.928 960 64 759.04 64 512S265.056 64 512.032 64M512.032 0C229.184 0 0 229.216 0 512s229.184 512 512.064 512c282.752 0 512-229.216 512-512S794.816 0 512.032 0L512.032 0z" fill="currentColor" p-id="11717"></path><path d="M224 512m-80 0a2.5 2.5 0 1 0 160 0 2.5 2.5 0 1 0-160 0Z" fill="currentColor" p-id="11718"></path><path d="M512.032 512m-80 0a2.5 2.5 0 1 0 160 0 2.5 2.5 0 1 0-160 0Z" fill="currentColor" p-id="11719"></path><path d="M800.064 512m-80 0a2.5 2.5 0 1 0 160 0 2.5 2.5 0 1 0-160 0Z" fill="currentColor" p-id="11720"></path></svg>
          </i>
          <div class="uml-body" style="width: 100%;height:${
            !properties.isShowTitle ? "calc(100% - 30px)" : "100%"
          };border-top:none;padding: 0;display: flex;flex-direction: row;justify-content: center;align-items: center;">
            <div style="width: 100%;display:flex;flex-direction: row;align-items:center;justify-content: center;border-bottom-left-radius: 10px;border-bottom-right-radius: 10px;" id="embedCode_${id}">
              ${properties.embedCode}
            </div>
          </div>
        </div>
        `;
      }
      if (
        properties.radio == "imageList" &&
        properties.imageList &&
        properties.imageList.length != 0
      ) {
        // console.log(properties.imageList)
        el.id = "imageList_" + id;
        html = `
        <div class="is_show_user" style="${
          properties.is_show_user
            ? "display:flex;background: #fff;"
            : "display:none;background: #fff;"
        }">
        <i class="el-icon" style="font-size: 18px;color:#58aba2;width: 18px;height: 27px;" >
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024" ><path fill="currentColor" d="M628.736 528.896A416 416 0 0 1 928 928H96a415.872 415.872 0 0 1 299.264-399.104L512 704zM720 304a208 208 0 1 1-416 0 208 208 0 0 1 416 0"></path></svg>
        </i>
        <div class="is_show_user_name">${properties.user_name}</div>
        <i class="el-icon" style="font-size: 16px;width: 16px;height: 27px;"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024" ><path fill="currentColor" d="m199.04 672.64 193.984 112 224-387.968-193.92-112-224 388.032zm-23.872 60.16 32.896 148.288 144.896-45.696zM455.04 229.248l193.92 112 56.704-98.112-193.984-112-56.64 98.112zM104.32 708.8l384-665.024 304.768 175.936L409.152 884.8h.064l-248.448 78.336zm384 254.272v-64h448v64h-448z"></path></svg></i>
        <div class="apostrophe"></div>
      </div>
        <div style="width: 100%;height: 100%;overflow: hidden;">
          <div class="uml-head" style="background-color:${color};${
          !properties.isShowTitle ? "display:block;" : "display:none;"
        }">${properties.title ? properties.title : cardTitle}</div>
          <i id="${id}" title="${ window.location.href.indexOf("cocorobo.cn") != -1 ? zhHansLanguage.deleteGraps : window.location.href.indexOf("cocorobo.hk") != -1 ? zhHantLanguage.deleteGraps : enLanguage.deleteGraps }" class="${
            !properties.isShowTitle
              ? "el-icon closeImg"
              : "el-icon closeImgTheme"
            }" style="${
            properties.isShowDelete ? "display:block;font-size: 20px;" : "display:none;font-size: 20px;"
          }"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024" ><path fill="currentColor" d="m466.752 512-90.496-90.496a32 32 0 0 1 45.248-45.248L512 466.752l90.496-90.496a32 32 0 1 1 45.248 45.248L557.248 512l90.496 90.496a32 32 0 1 1-45.248 45.248L512 557.248l-90.496 90.496a32 32 0 0 1-45.248-45.248z"></path><path fill="currentColor" d="M512 896a384 384 0 1 0 0-768 384 384 0 0 0 0 768m0 64a448 448 0 1 1 0-896 448 448 0 0 1 0 896"></path></svg>
          </i>
          <i id="comment_${id}" title="${ window.location.href.indexOf("cocorobo.cn") != -1 ? zhHansLanguage.comment : window.location.href.indexOf("cocorobo.hk") != -1 ? zhHantLanguage.comment : enLanguage.comment }" class="el-icon closeImg" style="${
            properties.isShowDelete ? "display:block;font-size: 17px;right: 30px;top: 5px;" : "display:none;font-size: 17px;right: 30px;top: 5px;"
          }"><svg t="1728889233368" class="icon" viewBox="0 0 1025 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="11716" width="20" height="20"><path d="M512.032 64c247.04 0 448 200.96 448 448s-200.96 448-448 448C264.928 960 64 759.04 64 512S265.056 64 512.032 64M512.032 0C229.184 0 0 229.216 0 512s229.184 512 512.064 512c282.752 0 512-229.216 512-512S794.816 0 512.032 0L512.032 0z" fill="currentColor" p-id="11717"></path><path d="M224 512m-80 0a2.5 2.5 0 1 0 160 0 2.5 2.5 0 1 0-160 0Z" fill="currentColor" p-id="11718"></path><path d="M512.032 512m-80 0a2.5 2.5 0 1 0 160 0 2.5 2.5 0 1 0-160 0Z" fill="currentColor" p-id="11719"></path><path d="M800.064 512m-80 0a2.5 2.5 0 1 0 160 0 2.5 2.5 0 1 0-160 0Z" fill="currentColor" p-id="11720"></path></svg>
          </i>
          <div class="uml-body" style="${
            !properties.isShowTitle
              ? "height:calc(100% - 30px);"
              : "height:100%;"
          }width: 100%;padding:0;border-top:none;border-bottom-left-radius: 10px;border-bottom-right-radius: 10px;">
            <div style="width: 100%;height:100%;display:flex;align-items:center;justify-content: center;border-bottom-left-radius: 10px;border-bottom-right-radius: 10px;"><img id="img_${id}" crossorigin="anonymous" style="width: 100%;height: auto;max-width: 100%;max-height: 100%;border-bottom-left-radius: 10px;border-bottom-right-radius: 10px;" draggable="false" src="${
          properties.imageList[0].url
        }"/></div>
          </div>
        </div>
        `;
      }
      if (
        properties.radio == "videoList" &&
        properties.videoList &&
        properties.videoList.length != 0 &&
        properties.styleRadio == "1"
      ) {
        // console.log(properties.videoList)
        el.style = "background:#fff;border:none;";
        el.id = "video-" + id;
        html = `
        <div class="is_show_user" style="${
          properties.is_show_user
            ? "display:flex;background: #fff;"
            : "display:none;background: #fff;"
        }">
        <i class="el-icon" style="font-size: 18px;color:#58aba2;width: 18px;height: 27px;" >
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024" ><path fill="currentColor" d="M628.736 528.896A416 416 0 0 1 928 928H96a415.872 415.872 0 0 1 299.264-399.104L512 704zM720 304a208 208 0 1 1-416 0 208 208 0 0 1 416 0"></path></svg>
        </i>
        <div class="is_show_user_name">${properties.user_name}</div>
        <i class="el-icon" style="font-size: 16px;width: 16px;height: 27px;"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024" ><path fill="currentColor" d="m199.04 672.64 193.984 112 224-387.968-193.92-112-224 388.032zm-23.872 60.16 32.896 148.288 144.896-45.696zM455.04 229.248l193.92 112 56.704-98.112-193.984-112-56.64 98.112zM104.32 708.8l384-665.024 304.768 175.936L409.152 884.8h.064l-248.448 78.336zm384 254.272v-64h448v64h-448z"></path></svg></i>
        <div class="apostrophe"></div>
      </div>
        <div style="width: 100%;height: 100%;overflow: hidden;">
          <div class="uml-head" style="background-color:${color};${
          !properties.isShowTitle ? "display:block;" : "display:none;"
        }">${properties.title ? properties.title : cardTitle}</div>
          <i id="${id}" title="${ window.location.href.indexOf("cocorobo.cn") != -1 ? zhHansLanguage.deleteGraps : window.location.href.indexOf("cocorobo.hk") != -1 ? zhHantLanguage.deleteGraps : enLanguage.deleteGraps }" class="el-icon closeImg" style="${
            properties.isShowDelete ? "display:block;z-index: 2000;font-size: 20px;" : "display:none;font-size: 20px;"
          }"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024" ><path fill="currentColor" d="m466.752 512-90.496-90.496a32 32 0 0 1 45.248-45.248L512 466.752l90.496-90.496a32 32 0 1 1 45.248 45.248L557.248 512l90.496 90.496a32 32 0 1 1-45.248 45.248L512 557.248l-90.496 90.496a32 32 0 0 1-45.248-45.248z"></path><path fill="currentColor" d="M512 896a384 384 0 1 0 0-768 384 384 0 0 0 0 768m0 64a448 448 0 1 1 0-896 448 448 0 0 1 0 896"></path></svg>
          </i>
          <i id="comment_${id}" title="${ window.location.href.indexOf("cocorobo.cn") != -1 ? zhHansLanguage.comment : window.location.href.indexOf("cocorobo.hk") != -1 ? zhHantLanguage.comment : enLanguage.comment }" class="el-icon closeImg" style="${
            properties.isShowDelete ? "display:block;font-size: 17px;right: 30px;top: 5px;" : "display:none;font-size: 17px;right: 30px;top: 5px;"
          }"><svg t="1728889233368" class="icon" viewBox="0 0 1025 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="11716" width="20" height="20"><path d="M512.032 64c247.04 0 448 200.96 448 448s-200.96 448-448 448C264.928 960 64 759.04 64 512S265.056 64 512.032 64M512.032 0C229.184 0 0 229.216 0 512s229.184 512 512.064 512c282.752 0 512-229.216 512-512S794.816 0 512.032 0L512.032 0z" fill="currentColor" p-id="11717"></path><path d="M224 512m-80 0a2.5 2.5 0 1 0 160 0 2.5 2.5 0 1 0-160 0Z" fill="currentColor" p-id="11718"></path><path d="M512.032 512m-80 0a2.5 2.5 0 1 0 160 0 2.5 2.5 0 1 0-160 0Z" fill="currentColor" p-id="11719"></path><path d="M800.064 512m-80 0a2.5 2.5 0 1 0 160 0 2.5 2.5 0 1 0-160 0Z" fill="currentColor" p-id="11720"></path></svg>
          </i>
          <div class="uml-body" style="${
            !properties.isShowTitle
              ? "height:calc(100% - 30px);"
              : "height:100%;"
          }border-top:none;width: 100%;;padding:0;display: flex;flex-direction: row;justify-content: center;align-items: center;">
            <div style="width: 100%;display: flex;align-items: center;justify-content: center;border-bottom-left-radius: 10px;border-bottom-right-radius: 10px;"><video id="video_${id}" style="width: auto;height: auto;max-width: 100%;max-height: 100%;border-bottom-left-radius: 10px;border-bottom-right-radius: 10px;" controls src="${
          properties.videoList[0].url
        }"></video></div>
          </div>
        </div>
        `;
      }
      if (
        properties.radio == "videoList" &&
        properties.videoList &&
        properties.videoList.length != 0 &&
        properties.styleRadio == "2"
      ) {
        // console.log(properties)
        // console.log(id)
        el.style = "height: auto;";
        el.id = "video-" + id;
        html = `
        <div class="is_show_user" style="${
          properties.is_show_user
            ? "display:flex;background: #fff;"
            : "display:none;background: #fff;"
        }">
        <i class="el-icon" style="font-size: 18px;color:#58aba2;width: 18px;height: 27px;" >
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024" ><path fill="currentColor" d="M628.736 528.896A416 416 0 0 1 928 928H96a415.872 415.872 0 0 1 299.264-399.104L512 704zM720 304a208 208 0 1 1-416 0 208 208 0 0 1 416 0"></path></svg>
        </i>
        <div class="is_show_user_name">${properties.user_name}</div>
        <i class="el-icon" style="font-size: 16px;width: 16px;height: 27px;"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024" ><path fill="currentColor" d="m199.04 672.64 193.984 112 224-387.968-193.92-112-224 388.032zm-23.872 60.16 32.896 148.288 144.896-45.696zM455.04 229.248l193.92 112 56.704-98.112-193.984-112-56.64 98.112zM104.32 708.8l384-665.024 304.768 175.936L409.152 884.8h.064l-248.448 78.336zm384 254.272v-64h448v64h-448z"></path></svg></i>
        <div class="apostrophe"></div>
      </div>
        <div style="width: 100%;height: auto;overflow: hidden;">
          <div class="uml-head" style="background-color:${color};${
          !properties.isShowTitle ? "display:block;" : "display:none;"
        }">${properties.title ? properties.title : cardTitle}</div>
          <i id="${id}" title="${ window.location.href.indexOf("cocorobo.cn") != -1 ? zhHansLanguage.deleteGraps : window.location.href.indexOf("cocorobo.hk") != -1 ? zhHantLanguage.deleteGraps : enLanguage.deleteGraps }" class="el-icon closeImg" style="${
            properties.isShowDelete ? "display:block;z-index: 2000;font-size: 20px;" : "display:none;font-size: 20px;"
          }"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024" ><path fill="currentColor" d="m466.752 512-90.496-90.496a32 32 0 0 1 45.248-45.248L512 466.752l90.496-90.496a32 32 0 1 1 45.248 45.248L557.248 512l90.496 90.496a32 32 0 1 1-45.248 45.248L512 557.248l-90.496 90.496a32 32 0 0 1-45.248-45.248z"></path><path fill="currentColor" d="M512 896a384 384 0 1 0 0-768 384 384 0 0 0 0 768m0 64a448 448 0 1 1 0-896 448 448 0 0 1 0 896"></path></svg>
          </i>
          <i id="comment_${id}" title="${ window.location.href.indexOf("cocorobo.cn") != -1 ? zhHansLanguage.comment : window.location.href.indexOf("cocorobo.hk") != -1 ? zhHantLanguage.comment : enLanguage.comment }" class="el-icon closeImg" style="${
            properties.isShowDelete ? "display:block;font-size: 17px;right: 30px;top: 5px;" : "display:none;font-size: 17px;right: 30px;top: 5px;"
          }"><svg t="1728889233368" class="icon" viewBox="0 0 1025 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="11716" width="20" height="20"><path d="M512.032 64c247.04 0 448 200.96 448 448s-200.96 448-448 448C264.928 960 64 759.04 64 512S265.056 64 512.032 64M512.032 0C229.184 0 0 229.216 0 512s229.184 512 512.064 512c282.752 0 512-229.216 512-512S794.816 0 512.032 0L512.032 0z" fill="currentColor" p-id="11717"></path><path d="M224 512m-80 0a2.5 2.5 0 1 0 160 0 2.5 2.5 0 1 0-160 0Z" fill="currentColor" p-id="11718"></path><path d="M512.032 512m-80 0a2.5 2.5 0 1 0 160 0 2.5 2.5 0 1 0-160 0Z" fill="currentColor" p-id="11719"></path><path d="M800.064 512m-80 0a2.5 2.5 0 1 0 160 0 2.5 2.5 0 1 0-160 0Z" fill="currentColor" p-id="11720"></path></svg>
          </i>
          <div class="uml-body" style="border-top:none;width: 100%;height: auto;padding:0;border-bottom-left-radius: 10px;border-bottom-right-radius: 10px;">
            <div style="width: 100%;height: auto;border-bottom-left-radius: 10px;border-bottom-right-radius: 10px;"><video id="video_${id}" style="width: auto;height:auto;max-width: 100%;max-height: 100%;display: block;border-bottom-left-radius: 10px;border-bottom-right-radius: 10px;" controls src="${
          properties.videoList[0].url
        }"></video></div>
          </div>
        </div>
        `;
      }
      if (
        properties.radio == "audioList" &&
        properties.audioList &&
        properties.audioList.length != 0
      ) {
        // console.log(properties.audioList)
        el.id = "audio-" + id;
        html = `
        <div class="is_show_user" style="${
          properties.is_show_user ? "display:flex;" : "display:none;"
        }">
          <i class="el-icon" style="font-size: 18px;color:#58aba2;width: 18px;height: 27px;" >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024" ><path fill="currentColor" d="M628.736 528.896A416 416 0 0 1 928 928H96a415.872 415.872 0 0 1 299.264-399.104L512 704zM720 304a208 208 0 1 1-416 0 208 208 0 0 1 416 0"></path></svg>
          </i>
          <div class="is_show_user_name">${properties.user_name}</div>
          <i class="el-icon" style="font-size: 16px;width: 16px;height: 27px;"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024" ><path fill="currentColor" d="m199.04 672.64 193.984 112 224-387.968-193.92-112-224 388.032zm-23.872 60.16 32.896 148.288 144.896-45.696zM455.04 229.248l193.92 112 56.704-98.112-193.984-112-56.64 98.112zM104.32 708.8l384-665.024 304.768 175.936L409.152 884.8h.064l-248.448 78.336zm384 254.272v-64h448v64h-448z"></path></svg></i>
          <div class="apostrophe"></div>
        </div>
        <div style="width: 100%;height: 100%;overflow: hidden;">
          <div class="uml-head" style="background-color:${color};${
          !properties.isShowTitle ? "display:block;" : "display:none;"
        }">${properties.title ? properties.title : cardTitle}</div>
          <i id="${id}" title="${ window.location.href.indexOf("cocorobo.cn") != -1 ? zhHansLanguage.deleteGraps : window.location.href.indexOf("cocorobo.hk") != -1 ? zhHantLanguage.deleteGraps : enLanguage.deleteGraps }" class="${
            !properties.isShowTitle
              ? "el-icon closeImg"
              : "el-icon closeImgTheme"
            }" style="${
            properties.isShowDelete ? "display:block;font-size: 20px;" : "display:none;font-size: 20px;"
          }"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024" ><path fill="currentColor" d="m466.752 512-90.496-90.496a32 32 0 0 1 45.248-45.248L512 466.752l90.496-90.496a32 32 0 1 1 45.248 45.248L557.248 512l90.496 90.496a32 32 0 1 1-45.248 45.248L512 557.248l-90.496 90.496a32 32 0 0 1-45.248-45.248z"></path><path fill="currentColor" d="M512 896a384 384 0 1 0 0-768 384 384 0 0 0 0 768m0 64a448 448 0 1 1 0-896 448 448 0 0 1 0 896"></path></svg>
          </i>
          <i id="comment_${id}" title="${ window.location.href.indexOf("cocorobo.cn") != -1 ? zhHansLanguage.comment : window.location.href.indexOf("cocorobo.hk") != -1 ? zhHantLanguage.comment : enLanguage.comment }" class="el-icon closeImg" style="${
            properties.isShowDelete ? "display:block;font-size: 17px;right: 30px;top: 5px;" : "display:none;font-size: 17px;right: 30px;top: 5px;"
          }"><svg t="1728889233368" class="icon" viewBox="0 0 1025 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="11716" width="20" height="20"><path d="M512.032 64c247.04 0 448 200.96 448 448s-200.96 448-448 448C264.928 960 64 759.04 64 512S265.056 64 512.032 64M512.032 0C229.184 0 0 229.216 0 512s229.184 512 512.064 512c282.752 0 512-229.216 512-512S794.816 0 512.032 0L512.032 0z" fill="currentColor" p-id="11717"></path><path d="M224 512m-80 0a2.5 2.5 0 1 0 160 0 2.5 2.5 0 1 0-160 0Z" fill="currentColor" p-id="11718"></path><path d="M512.032 512m-80 0a2.5 2.5 0 1 0 160 0 2.5 2.5 0 1 0-160 0Z" fill="currentColor" p-id="11719"></path><path d="M800.064 512m-80 0a2.5 2.5 0 1 0 160 0 2.5 2.5 0 1 0-160 0Z" fill="currentColor" p-id="11720"></path></svg>
          </i>
          <div class="uml-body" style="border-top:none;display:flex;width: 100%;height:${
            !properties.isShowTitle ? "calc(100% - 30px)" : "100%"
          };justify-content: center;align-items: center;padding:0;border-bottom-left-radius: 10px;border-bottom-right-radius: 10px;">
            <div style="display:flex;width: 100%;justify-content: center;align-items: center;border-bottom-left-radius: 10px;border-bottom-right-radius: 10px;"><audio id="audio_${id}" src="${
          properties.audioList[0].url
        }" controls /></div>
          </div>
        </div>
        `;
      }
      if (
        properties.radio == "fileList" &&
        properties.fileList &&
        properties.fileList.length != 0 &&
        (properties.fileList[0].url.indexOf(".pdf") != -1 ||
          properties.fileList[0].url.indexOf(".PDF") != -1)
      ) {
        el.id = "fileList-" + id;
        html = `
        <div class="is_show_user" style="${
          properties.is_show_user
            ? "display:flex;z-index: 9999;position: relative;background: #fff;"
            : "display:none;z-index: 9999;position: relative;background: #fff;"
        }">
          <i class="el-icon" style="font-size: 18px;color:#58aba2;width: 18px;height: 27px;" >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024" ><path fill="currentColor" d="M628.736 528.896A416 416 0 0 1 928 928H96a415.872 415.872 0 0 1 299.264-399.104L512 704zM720 304a208 208 0 1 1-416 0 208 208 0 0 1 416 0"></path></svg>
          </i>
          <div class="is_show_user_name">${properties.user_name}</div>
          <i class="el-icon" style="font-size: 16px;width: 16px;height: 27px;"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024" ><path fill="currentColor" d="m199.04 672.64 193.984 112 224-387.968-193.92-112-224 388.032zm-23.872 60.16 32.896 148.288 144.896-45.696zM455.04 229.248l193.92 112 56.704-98.112-193.984-112-56.64 98.112zM104.32 708.8l384-665.024 304.768 175.936L409.152 884.8h.064l-248.448 78.336zm384 254.272v-64h448v64h-448z"></path></svg></i>
          <div class="apostrophe"></div>
        </div>
        <div style="height:100%;overflow: hidden;">
          <div class="uml-head" style="background-color:${color};${
          !properties.isShowTitle
            ? "display:block;position: relative;z-index: 9999;"
            : "display:none;position: relative;z-index: 9999;"
        }">${properties.title ? properties.title : cardTitle}</div>
          <i id="${id}" title="${ window.location.href.indexOf("cocorobo.cn") != -1 ? zhHansLanguage.deleteGraps : window.location.href.indexOf("cocorobo.hk") != -1 ? zhHantLanguage.deleteGraps : enLanguage.deleteGraps }" class="${
            !properties.isShowTitle && !properties.is_show_user
              ? "el-icon closeImg"
              : "el-icon closeImgTheme"
            }" style="${
            properties.isShowDelete ? "display:block;z-index: 9999;font-size: 20px;" : "display:none;z-index: 9999;font-size: 20px;"
          }"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024" ><path fill="currentColor" d="m466.752 512-90.496-90.496a32 32 0 0 1 45.248-45.248L512 466.752l90.496-90.496a32 32 0 1 1 45.248 45.248L557.248 512l90.496 90.496a32 32 0 1 1-45.248 45.248L512 557.248l-90.496 90.496a32 32 0 0 1-45.248-45.248z"></path><path fill="currentColor" d="M512 896a384 384 0 1 0 0-768 384 384 0 0 0 0 768m0 64a448 448 0 1 1 0-896 448 448 0 0 1 0 896"></path></svg>
          </i>
          <i id="comment_${id}" title="${ window.location.href.indexOf("cocorobo.cn") != -1 ? zhHansLanguage.comment : window.location.href.indexOf("cocorobo.hk") != -1 ? zhHantLanguage.comment : enLanguage.comment }" class="el-icon closeImg" style="${
            properties.isShowDelete ? "display:block;font-size: 17px;right: 30px;top: 5px;" : "display:none;font-size: 17px;right: 30px;top: 5px;"
          }"><svg t="1728889233368" class="icon" viewBox="0 0 1025 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="11716" width="20" height="20"><path d="M512.032 64c247.04 0 448 200.96 448 448s-200.96 448-448 448C264.928 960 64 759.04 64 512S265.056 64 512.032 64M512.032 0C229.184 0 0 229.216 0 512s229.184 512 512.064 512c282.752 0 512-229.216 512-512S794.816 0 512.032 0L512.032 0z" fill="currentColor" p-id="11717"></path><path d="M224 512m-80 0a2.5 2.5 0 1 0 160 0 2.5 2.5 0 1 0-160 0Z" fill="currentColor" p-id="11718"></path><path d="M512.032 512m-80 0a2.5 2.5 0 1 0 160 0 2.5 2.5 0 1 0-160 0Z" fill="currentColor" p-id="11719"></path><path d="M800.064 512m-80 0a2.5 2.5 0 1 0 160 0 2.5 2.5 0 1 0-160 0Z" fill="currentColor" p-id="11720"></path></svg>
          </i>
          <div class="uml-body" style="height:${
            !properties.isShowTitle ? "calc(100% - 30px)" : "calc(100%)"
          };width: 100%;padding:0;border-top:none;border-bottom-left-radius: 10px;border-bottom-right-radius: 10px;">
            <div id="file_${id}" style="width: 100%;height:100%;">
              <iframe id="myframe_${id}" draggable="false" src=${
          "https://cloud.cocorobo.cn/pdf.js/web/viewer.html?file=" +
          properties.fileList[0].url
        } style="position: absolute;transform: scale(.5, .5) translate(-47%, -50%);width: 189%;height:206%;top: ${
          !properties.isShowTitle && properties.is_show_user
            ? "28px"
            : !properties.isShowTitle && !properties.is_show_user
            ? "13px"
            : properties.isShowTitle && properties.is_show_user
            ? "33px"
            : "3px"
        };left: 0;right: 0;" frameborder="no" border="0"></iframe></div>
            </div>
        </div>
        `;
      }
      if (
        properties.radio == "fileList" &&
        properties.fileList &&
        properties.fileList.length != 0 &&
        (properties.fileList[0].url.indexOf(".doc") != -1 ||
          properties.fileList[0].url.indexOf(".DOC") != -1 ||
          properties.fileList[0].url.indexOf(".docx") != -1 ||
          properties.fileList[0].url.indexOf(".DOCX") != -1)
      ) {
        el.id = "fileList-" + id;
        html = `
        <div class="is_show_user" style="${
          properties.is_show_user
            ? "display:flex;z-index: 9999;position: relative;background: #fff;"
            : "display:none;z-index: 9999;position: relative;background: #fff;"
        }">
          <i class="el-icon" style="font-size: 18px;color:#58aba2;width: 18px;height: 27px;" >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024" ><path fill="currentColor" d="M628.736 528.896A416 416 0 0 1 928 928H96a415.872 415.872 0 0 1 299.264-399.104L512 704zM720 304a208 208 0 1 1-416 0 208 208 0 0 1 416 0"></path></svg>
          </i>
          <div class="is_show_user_name">${properties.user_name}</div>
          <i class="el-icon" style="font-size: 16px;width: 16px;height: 27px;"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024" ><path fill="currentColor" d="m199.04 672.64 193.984 112 224-387.968-193.92-112-224 388.032zm-23.872 60.16 32.896 148.288 144.896-45.696zM455.04 229.248l193.92 112 56.704-98.112-193.984-112-56.64 98.112zM104.32 708.8l384-665.024 304.768 175.936L409.152 884.8h.064l-248.448 78.336zm384 254.272v-64h448v64h-448z"></path></svg></i>
          <div class="apostrophe"></div>
        </div>
        <div style="height:100%;overflow: hidden;">
          <div class="uml-head" style="background-color:${color};${
          !properties.isShowTitle
            ? "display:block;position: relative;z-index: 9999;"
            : "display:none;position: relative;z-index: 9999;"
        }">${properties.title ? properties.title : cardTitle}</div>
          <i id="${id}" title="${ window.location.href.indexOf("cocorobo.cn") != -1 ? zhHansLanguage.deleteGraps : window.location.href.indexOf("cocorobo.hk") != -1 ? zhHantLanguage.deleteGraps : enLanguage.deleteGraps }" class="${
            !properties.isShowTitle && !properties.is_show_user
              ? "el-icon closeImg"
              : "el-icon closeImgTheme"
            }" style="${
            properties.isShowDelete ? "display:block;z-index: 9999;font-size: 20px;" : "display:none;z-index: 9999;font-size: 20px;"
          }"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024" ><path fill="currentColor" d="m466.752 512-90.496-90.496a32 32 0 0 1 45.248-45.248L512 466.752l90.496-90.496a32 32 0 1 1 45.248 45.248L557.248 512l90.496 90.496a32 32 0 1 1-45.248 45.248L512 557.248l-90.496 90.496a32 32 0 0 1-45.248-45.248z"></path><path fill="currentColor" d="M512 896a384 384 0 1 0 0-768 384 384 0 0 0 0 768m0 64a448 448 0 1 1 0-896 448 448 0 0 1 0 896"></path></svg>
          </i>
          <i id="comment_${id}" title="${ window.location.href.indexOf("cocorobo.cn") != -1 ? zhHansLanguage.comment : window.location.href.indexOf("cocorobo.hk") != -1 ? zhHantLanguage.comment : enLanguage.comment }" class="el-icon closeImg" style="${
            properties.isShowDelete ? "display:block;font-size: 17px;right: 30px;top: 5px;" : "display:none;font-size: 17px;right: 30px;top: 5px;"
          }"><svg t="1728889233368" class="icon" viewBox="0 0 1025 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="11716" width="20" height="20"><path d="M512.032 64c247.04 0 448 200.96 448 448s-200.96 448-448 448C264.928 960 64 759.04 64 512S265.056 64 512.032 64M512.032 0C229.184 0 0 229.216 0 512s229.184 512 512.064 512c282.752 0 512-229.216 512-512S794.816 0 512.032 0L512.032 0z" fill="currentColor" p-id="11717"></path><path d="M224 512m-80 0a2.5 2.5 0 1 0 160 0 2.5 2.5 0 1 0-160 0Z" fill="currentColor" p-id="11718"></path><path d="M512.032 512m-80 0a2.5 2.5 0 1 0 160 0 2.5 2.5 0 1 0-160 0Z" fill="currentColor" p-id="11719"></path><path d="M800.064 512m-80 0a2.5 2.5 0 1 0 160 0 2.5 2.5 0 1 0-160 0Z" fill="currentColor" p-id="11720"></path></svg>
          </i>
          <div class="uml-body" style="height:${
            !properties.isShowTitle ? "calc(100% - 30px)" : "calc(100%)"
          };width: 100%;padding:0;border-top:none;border-bottom-left-radius: 10px;border-bottom-right-radius: 10px;">
            <div id="file_${id}" style="width: 100%;height:100%;">
              <iframe id="myframe_${id}" draggable="false" src=${
          "https://view.officeapps.live.com/op/view.aspx?src=" +
          properties.fileList[0].url
        } style="position: absolute;transform: scale(.5, .5) translate(-47%, -50%);width: 187%;height:206%;top: ${
          !properties.isShowTitle ? "-16px" : "3px"
        };left: 0;right: 0;" frameborder="no" border="0"></iframe></div>
            </div>
        </div>
        `;
      }
      if (
        properties.radio == "fileList" &&
        properties.fileList &&
        properties.fileList.length != 0 &&
        (properties.fileList[0].url.indexOf(".ppt") != -1 ||
          properties.fileList[0].url.indexOf(".PPT") != -1 ||
          properties.fileList[0].url.indexOf(".pptx") != -1 ||
          properties.fileList[0].url.indexOf(".PPTX") != -1)
      ) {
        el.id = "fileList-" + id;
        html = `
        <div class="is_show_user" style="${
          properties.is_show_user
            ? "display:flex;z-index: 9999;position: relative;background: #fff;"
            : "display:none;z-index: 9999;position: relative;background: #fff;"
        }">
          <i class="el-icon" style="font-size: 18px;color:#58aba2;width: 18px;height: 27px;" >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024" ><path fill="currentColor" d="M628.736 528.896A416 416 0 0 1 928 928H96a415.872 415.872 0 0 1 299.264-399.104L512 704zM720 304a208 208 0 1 1-416 0 208 208 0 0 1 416 0"></path></svg>
          </i>
          <div class="is_show_user_name">${properties.user_name}</div>
          <i class="el-icon" style="font-size: 16px;width: 16px;height: 27px;"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024" ><path fill="currentColor" d="m199.04 672.64 193.984 112 224-387.968-193.92-112-224 388.032zm-23.872 60.16 32.896 148.288 144.896-45.696zM455.04 229.248l193.92 112 56.704-98.112-193.984-112-56.64 98.112zM104.32 708.8l384-665.024 304.768 175.936L409.152 884.8h.064l-248.448 78.336zm384 254.272v-64h448v64h-448z"></path></svg></i>
          <div class="apostrophe"></div>
        </div>
        <div style="height:100%;overflow: hidden;">
          <div class="uml-head" style="background-color:${color};${
          !properties.isShowTitle
            ? "display:block;position: relative;z-index: 9999;"
            : "display:none;position: relative;z-index: 9999;"
        }">${properties.title ? properties.title : cardTitle}</div>
          <i id="${id}" title="${ window.location.href.indexOf("cocorobo.cn") != -1 ? zhHansLanguage.deleteGraps : window.location.href.indexOf("cocorobo.hk") != -1 ? zhHantLanguage.deleteGraps : enLanguage.deleteGraps }" class="${
            !properties.isShowTitle && !properties.is_show_user
              ? "el-icon closeImg"
              : "el-icon closeImgTheme"
            }" style="${
            properties.isShowDelete ? "display:block;z-index: 9999;font-size: 20px;" : "display:none;z-index: 9999;font-size: 20px;"
          }"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024" ><path fill="currentColor" d="m466.752 512-90.496-90.496a32 32 0 0 1 45.248-45.248L512 466.752l90.496-90.496a32 32 0 1 1 45.248 45.248L557.248 512l90.496 90.496a32 32 0 1 1-45.248 45.248L512 557.248l-90.496 90.496a32 32 0 0 1-45.248-45.248z"></path><path fill="currentColor" d="M512 896a384 384 0 1 0 0-768 384 384 0 0 0 0 768m0 64a448 448 0 1 1 0-896 448 448 0 0 1 0 896"></path></svg>
          </i>
          <i id="comment_${id}" title="${ window.location.href.indexOf("cocorobo.cn") != -1 ? zhHansLanguage.comment : window.location.href.indexOf("cocorobo.hk") != -1 ? zhHantLanguage.comment : enLanguage.comment }" class="el-icon closeImg" style="${
            properties.isShowDelete ? "display:block;font-size: 17px;right: 30px;top: 5px;" : "display:none;font-size: 17px;right: 30px;top: 5px;"
          }"><svg t="1728889233368" class="icon" viewBox="0 0 1025 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="11716" width="20" height="20"><path d="M512.032 64c247.04 0 448 200.96 448 448s-200.96 448-448 448C264.928 960 64 759.04 64 512S265.056 64 512.032 64M512.032 0C229.184 0 0 229.216 0 512s229.184 512 512.064 512c282.752 0 512-229.216 512-512S794.816 0 512.032 0L512.032 0z" fill="currentColor" p-id="11717"></path><path d="M224 512m-80 0a2.5 2.5 0 1 0 160 0 2.5 2.5 0 1 0-160 0Z" fill="currentColor" p-id="11718"></path><path d="M512.032 512m-80 0a2.5 2.5 0 1 0 160 0 2.5 2.5 0 1 0-160 0Z" fill="currentColor" p-id="11719"></path><path d="M800.064 512m-80 0a2.5 2.5 0 1 0 160 0 2.5 2.5 0 1 0-160 0Z" fill="currentColor" p-id="11720"></path></svg>
          </i>
          <div class="uml-body" style="height:${
            !properties.isShowTitle ? "calc(100% - 30px)" : "calc(100%)"
          };width: 100%;padding:0;border-top:none;border-bottom-left-radius: 10px;border-bottom-right-radius: 10px;">
            <div id="file_${id}" style="width: 100%;height:100%;">
              <iframe id="myframe_${id}" draggable="false" src=${
          "https://view.officeapps.live.com/op/view.aspx?src=" +
          properties.fileList[0].url
        } style="position: absolute;transform: scale(.5, .5) translate(-47%, -50%);width: 189%;height:206%;top: ${
          !properties.isShowTitle ? "-16px" : "3px"
        };left: 0;right: 0;" frameborder="no" border="0"></iframe></div>
            </div>
        </div>
        `;
      }
      if (
        properties.radio == "fileList" &&
        properties.fileList &&
        properties.fileList.length != 0 &&
        (properties.fileList[0].url.indexOf(".xls") != -1 ||
          properties.fileList[0].url.indexOf(".XLS") != -1 ||
          properties.fileList[0].url.indexOf(".xlsx") != -1 ||
          properties.fileList[0].url.indexOf(".XLSAX") != -1)
      ) {
        el.id = "fileList-" + id;
        html = `
        <div class="is_show_user" style="${
          properties.is_show_user
            ? "display:flex;z-index: 9999;position: relative;background: #fff;"
            : "display:none;z-index: 9999;position: relative;background: #fff;"
        }">
          <i class="el-icon" style="font-size: 18px;color:#58aba2;width: 18px;height: 27px;" >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024" ><path fill="currentColor" d="M628.736 528.896A416 416 0 0 1 928 928H96a415.872 415.872 0 0 1 299.264-399.104L512 704zM720 304a208 208 0 1 1-416 0 208 208 0 0 1 416 0"></path></svg>
          </i>
          <div class="is_show_user_name">${properties.user_name}</div>
          <i class="el-icon" style="font-size: 16px;width: 16px;height: 27px;"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024" ><path fill="currentColor" d="m199.04 672.64 193.984 112 224-387.968-193.92-112-224 388.032zm-23.872 60.16 32.896 148.288 144.896-45.696zM455.04 229.248l193.92 112 56.704-98.112-193.984-112-56.64 98.112zM104.32 708.8l384-665.024 304.768 175.936L409.152 884.8h.064l-248.448 78.336zm384 254.272v-64h448v64h-448z"></path></svg></i>
          <div class="apostrophe"></div>
        </div>
        <div style="height:100%;overflow: hidden;">
          <div class="uml-head" style="background-color:${color};${
          !properties.isShowTitle
            ? "display:block;position: relative;z-index: 9999;"
            : "display:none;position: relative;z-index: 9999;"
        }">${properties.title ? properties.title : cardTitle}</div>
          <i id="${id}" title="${ window.location.href.indexOf("cocorobo.cn") != -1 ? zhHansLanguage.deleteGraps : window.location.href.indexOf("cocorobo.hk") != -1 ? zhHantLanguage.deleteGraps : enLanguage.deleteGraps }" class="${
            !properties.isShowTitle && !properties.is_show_user
              ? "el-icon closeImg"
              : "el-icon closeImgTheme"
            }" style="${
            properties.isShowDelete ? "display:block;z-index: 9999;font-size: 20px;" : "display:none;z-index: 9999;font-size: 20px;"
          }"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024" ><path fill="currentColor" d="m466.752 512-90.496-90.496a32 32 0 0 1 45.248-45.248L512 466.752l90.496-90.496a32 32 0 1 1 45.248 45.248L557.248 512l90.496 90.496a32 32 0 1 1-45.248 45.248L512 557.248l-90.496 90.496a32 32 0 0 1-45.248-45.248z"></path><path fill="currentColor" d="M512 896a384 384 0 1 0 0-768 384 384 0 0 0 0 768m0 64a448 448 0 1 1 0-896 448 448 0 0 1 0 896"></path></svg>
          </i>
          <i id="comment_${id}" title="${ window.location.href.indexOf("cocorobo.cn") != -1 ? zhHansLanguage.comment : window.location.href.indexOf("cocorobo.hk") != -1 ? zhHantLanguage.comment : enLanguage.comment }" class="el-icon closeImg" style="${
            properties.isShowDelete ? "display:block;font-size: 17px;right: 30px;top: 5px;" : "display:none;font-size: 17px;right: 30px;top: 5px;"
          }"><svg t="1728889233368" class="icon" viewBox="0 0 1025 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="11716" width="20" height="20"><path d="M512.032 64c247.04 0 448 200.96 448 448s-200.96 448-448 448C264.928 960 64 759.04 64 512S265.056 64 512.032 64M512.032 0C229.184 0 0 229.216 0 512s229.184 512 512.064 512c282.752 0 512-229.216 512-512S794.816 0 512.032 0L512.032 0z" fill="currentColor" p-id="11717"></path><path d="M224 512m-80 0a2.5 2.5 0 1 0 160 0 2.5 2.5 0 1 0-160 0Z" fill="currentColor" p-id="11718"></path><path d="M512.032 512m-80 0a2.5 2.5 0 1 0 160 0 2.5 2.5 0 1 0-160 0Z" fill="currentColor" p-id="11719"></path><path d="M800.064 512m-80 0a2.5 2.5 0 1 0 160 0 2.5 2.5 0 1 0-160 0Z" fill="currentColor" p-id="11720"></path></svg>
          </i>
          <div class="uml-body" style="height:${
            !properties.isShowTitle ? "calc(100% - 30px)" : "calc(100%)"
          };width: 100%;padding:0;border-top:none;border-bottom-left-radius: 10px;border-bottom-right-radius: 10px;">
            <div id="file_${id}" style="width: 100%;height:100%;">
              <iframe id="myframe_${id}" draggable="false" src=${
          "https://view.officeapps.live.com/op/view.aspx?src=" +
          properties.fileList[0].url
        } style="position: absolute;transform: scale(.5, .5) translate(-47%, -50%);width: 189%;height:206%;top: ${
          !properties.isShowTitle ? "-11px" : "3px"
        };left: 0;right: 0;" frameborder="no" border="0"></iframe></div>
            </div>
        </div>
        `;
      }
      el.innerHTML = html;
      // 需要先把之前渲染的子节点清除掉。
      rootEl.innerHTML = "";
      rootEl.appendChild(el);
      let that = this;
      if (document.getElementById(id)) {
        document.getElementById(id).addEventListener("click", (event) => {
          let tip18 =
            window.location.href.indexOf("cocorobo.cn") != -1
              ? zhHansLanguage.tip18
              : window.location.href.indexOf("cocorobo.hk") != -1
              ? zhHantLanguage.tip18
              : enLanguage.tip18;
          let tip2 =
            window.location.href.indexOf("cocorobo.cn") != -1
              ? zhHansLanguage.tip2
              : window.location.href.indexOf("cocorobo.hk") != -1
              ? zhHantLanguage.tip2
              : enLanguage.tip2;
          let confirm =
            window.location.href.indexOf("cocorobo.cn") != -1
              ? zhHansLanguage.confirm
              : window.location.href.indexOf("cocorobo.hk") != -1
              ? zhHantLanguage.confirm
              : enLanguage.confirm;
          let cancel =
            window.location.href.indexOf("cocorobo.cn") != -1
              ? zhHansLanguage.cancel
              : window.location.href.indexOf("cocorobo.hk") != -1
              ? zhHantLanguage.cancel
              : enLanguage.cancel;
          let nodes = [];
          nodes.push(that.props.graphModel.getElement(id).getData());

          MessageBox.confirm(tip18, tip2, {
            confirmButtonText: confirm,
            cancelButtonText: cancel,
            type: "warning",
          })
            .then(() => {
              let newEdges = [];
              let outgoingEdgeModel =
                that.props.graphModel.getNodeOutgoingEdge(id);
              if (outgoingEdgeModel.length != 0) {
                for (let j = 0; j < outgoingEdgeModel.length; j++) {
                  let edge = that.props.graphModel.getEdgeModelById(
                    outgoingEdgeModel[j].id
                  );
                  newEdges.push(edge.getData());
                }
              }
              let incomingEdgeModel =
                that.props.graphModel.getNodeIncomingEdge(id);
              if (incomingEdgeModel.length != 0) {
                for (let j = 0; j < incomingEdgeModel.length; j++) {
                  let edge = that.props.graphModel.getEdgeModelById(
                    incomingEdgeModel[j].id
                  );
                  newEdges.push(edge.getData());
                }
              }
              sendUpdate(nodes, newEdges, "delete", 0);
              that.props.graphModel.deleteNode(id);

              that.props.graphModel.clearSelectElements();
              let newData = {
                nodes: nodes,
                edges: newEdges,
                backgroundUrl: localStorage.getItem("background"),
              };
              add_Operation(newData, "deleteNode");
            })
            .catch(() => {
              // this.$message({
              //   type: 'info',
              //   message: '已取消删除'
              // });
            });
          event.stopPropagation();
        });
      }

      if (document.getElementById("comment_" + id)) {
        document.getElementById("comment_" + id).addEventListener("click", (event) => {
          let isShowComment = !properties.isShowComment
          this.props.model.properties.isShowComment = isShowComment
          event.stopPropagation();
        })
      }

      if (document.getElementById("content-" + id)) {
        $("#content-" + id)
          .parent()
          .removeAttr("style");
      }
      if (document.getElementById("iframeUrl-" + id)) {
        $("#iframeUrl-" + id)
          .parent()
          .removeAttr("style");
      }
      if (document.getElementById("embedCode-" + id)) {
        $("#embedCode-" + id)
          .parent()
          .removeAttr("style");
      }
      if (document.getElementById("imageList_" + id)) {
        $("#imageList_" + id)
          .parent()
          .removeAttr("style");
      }
      if (document.getElementById("video-" + id)) {
        $("#video-" + id)
          .parent()
          .removeAttr("style");
      }
      if (document.getElementById("audio-" + id)) {
        $("#audio-" + id)
          .parent()
          .removeAttr("style");
      }
      if (document.getElementById("fileList-" + id)) {
        $("#fileList-" + id)
          .parent()
          .removeAttr("style");
      }

      if (document.getElementById("myframe_" + id)) {
        document
          .getElementById("myframe_" + id)
          .addEventListener("mousedown", function (event) {
            event.preventDefault();
            return false;
          });
        document
          .getElementById("myframe_" + id)
          .addEventListener("mousemove", function (event) {
            event.preventDefault();
            return false;
          });
        document
          .getElementById("myframe_" + id)
          .addEventListener("mouseup", function (event) {
            event.preventDefault();
            return false;
          });
      }

      if (
        properties.radio == "videoList" &&
        properties.videoList &&
        properties.videoList.length != 0 &&
        properties.styleRadio == "2"
      ) {
        $("#video-" + id)
          .parent()
          .css("box-shadow", "none");
        // $("#video-" + id).parent().css("background", "none")
      }

      if(properties.isShowComment) {
        let comments = properties.commentList ? properties.commentList : [];
        let likes = properties.likeList ? properties.likeList : [];
        this.showComment(el, properties, comments, likes , this.props, id)
      }
      else {
        el.parentNode.style = "overflow: hidden;";
      }

      // let lf = this.props
      // if (properties.radio == 'content' && properties.content && properties.content != '' && properties.isShowTitle) {
      //   $("#content-" + id).parent().css("background", "#FFFFFF")
      //   $("#content-" + id).parent().css("box-shadow", "0px 2px 4px -1px rgba(0, 0, 0, 0.12), 0px 4px 5px 0px rgba(0, 0, 0, 0.08), 0px 1px 10px 0px rgba(0, 0, 0, 0.05)")
      //   lf.model.width = Math.round($("#content_" + id).width()) != 0 ? Math.round($("#content_" + id).width()) + 32 : 250
      //   lf.model.height = properties.nodeSize && properties.nodeSize.height ? properties.nodeSize.height : 250
      //   if(lf.model.properties.nodeSize && lf.model.properties.nodeSize.width) {
      //     lf.model.properties.nodeSize.width = lf.model.width
      //   }
      //   if(lf.model.properties.nodeSize && lf.model.properties.nodeSize.height) {
      //     lf.model.properties.nodeSize.height = lf.model.height
      //     $("#content_" + id).css("height", properties.is_show_user ? (properties.nodeSize.height - 27) + "px" : properties.nodeSize.height + "px")
      //   }
      //   let anchors = lf.model.anchors
      //   let edges = lf.model.graphModel.edges
      //   for (let i = 0; i < edges.length; i++) {
      //     for (let j = 0; j < anchors.length; j++) {
      //       if (edges[i].targetAnchorId == anchors[j].id) {
      //         lf.model.graphModel.edges[i].endPoint.x = anchors[j].x
      //         lf.model.graphModel.edges[i].endPoint.y = anchors[j].y
      //         break
      //       }
      //       if (edges[i].sourceAnchorId == anchors[j].id) {
      //         lf.model.graphModel.edges[i].startPoint.x = anchors[j].x
      //         lf.model.graphModel.edges[i].startPoint.y = anchors[j].y
      //         break
      //       }
      //     }
      //   }
      // }

      // if (properties.radio == 'content' && properties.content && properties.content != '' && !properties.isShowTitle) {
      //   $("#content-" + id).parent().css("background", "#FFFFFF")
      //   $("#content-" + id).parent().css("box-shadow", "0px 2px 4px -1px rgba(0, 0, 0, 0.12), 0px 4px 5px 0px rgba(0, 0, 0, 0.08), 0px 1px 10px 0px rgba(0, 0, 0, 0.05)")
      //   lf.model.width = Math.round($("#content_" + id).width()) != 0 ? Math.round($("#content_" + id).width()) + 32 : 250
      //   lf.model.height = properties.nodeSize && properties.nodeSize.height ? properties.nodeSize.height : 250
      //   if(lf.model.properties.nodeSize && lf.model.properties.nodeSize.width) {
      //     lf.model.properties.nodeSize.width = lf.model.width
      //   }
      //   if(lf.model.properties.nodeSize && lf.model.properties.nodeSize.height) {
      //     lf.model.properties.nodeSize.height = lf.model.height
      //     $("#content_" + id).css("height", properties.is_show_user ? (properties.nodeSize.height - 57) + "px" : (properties.nodeSize.height - 30) + "px")
      //   }
      //   let anchors = lf.model.anchors
      //   let edges = lf.model.graphModel.edges
      //   for (let i = 0; i < edges.length; i++) {
      //     for (let j = 0; j < anchors.length; j++) {
      //       if (edges[i].targetAnchorId == anchors[j].id) {
      //         lf.model.graphModel.edges[i].endPoint.x = anchors[j].x
      //         lf.model.graphModel.edges[i].endPoint.y = anchors[j].y
      //         break
      //       }
      //       if (edges[i].sourceAnchorId == anchors[j].id) {
      //         lf.model.graphModel.edges[i].startPoint.x = anchors[j].x
      //         lf.model.graphModel.edges[i].startPoint.y = anchors[j].y
      //         break
      //       }
      //     }
      //   }
      // }

      // if (properties.radio == 'embedCode' && properties.embedCode && properties.embedCode != '' && properties.isShowTitle) {
      //   $("#embedCode-" + id).parent().css("background", "#FFFFFF")
      //   $("#embedCode-" + id).parent().css("box-shadow", "0px 2px 4px -1px rgba(0, 0, 0, 0.12), 0px 4px 5px 0px rgba(0, 0, 0, 0.08), 0px 1px 10px 0px rgba(0, 0, 0, 0.05)")
      //   lf.model.width = Math.round($("#embedCode_" + id).width())
      //   lf.model.height = properties.is_show_user ? Math.round($("#embedCode_" + id).height()) + 77 : Math.round($("#embedCode_" + id).height()) + 50
      //   if(lf.model.properties.nodeSize && lf.model.properties.nodeSize.width) {
      //     lf.model.properties.nodeSize.width = lf.model.width
      //   }
      //   if(lf.model.properties.nodeSize && lf.model.properties.nodeSize.height) {
      //     lf.model.properties.nodeSize.height = lf.model.height
      //   }
      //   let anchors = lf.model.anchors
      //   let edges = lf.model.graphModel.edges
      //   for (let i = 0; i < edges.length; i++) {
      //     for (let j = 0; j < anchors.length; j++) {
      //       if (edges[i].targetAnchorId == anchors[j].id) {
      //         lf.model.graphModel.edges[i].endPoint.x = anchors[j].x
      //         lf.model.graphModel.edges[i].endPoint.y = anchors[j].y
      //         break
      //       }
      //       if (edges[i].sourceAnchorId == anchors[j].id) {
      //         lf.model.graphModel.edges[i].startPoint.x = anchors[j].x
      //         lf.model.graphModel.edges[i].startPoint.y = anchors[j].y
      //         break
      //       }
      //     }
      //   }
      // }

      // if (properties.radio == 'embedCode' && properties.embedCode && properties.embedCode != '' && !properties.isShowTitle) {
      //   $("#embedCode-" + id).parent().css("background", "#FFFFFF")
      //   $("#embedCode-" + id).parent().css("box-shadow", "0px 2px 4px -1px rgba(0, 0, 0, 0.12), 0px 4px 5px 0px rgba(0, 0, 0, 0.08), 0px 1px 10px 0px rgba(0, 0, 0, 0.05)")
      //   lf.model.width = Math.round($("#embedCode_" + id).width())
      //   lf.model.height = properties.is_show_user ? Math.round($("#embedCode_" + id).height()) + 87 : Math.round($("#embedCode_" + id).height()) + 60
      //   if(lf.model.properties.nodeSize && lf.model.properties.nodeSize.width) {
      //     lf.model.properties.nodeSize.width = lf.model.width
      //   }
      //   if(lf.model.properties.nodeSize && lf.model.properties.nodeSize.height) {
      //     lf.model.properties.nodeSize.height = lf.model.height
      //   }
      //   let anchors = lf.model.anchors
      //   let edges = lf.model.graphModel.edges
      //   for (let i = 0; i < edges.length; i++) {
      //     for (let j = 0; j < anchors.length; j++) {
      //       if (edges[i].targetAnchorId == anchors[j].id) {
      //         lf.model.graphModel.edges[i].endPoint.x = anchors[j].x
      //         lf.model.graphModel.edges[i].endPoint.y = anchors[j].y
      //         break
      //       }
      //       if (edges[i].sourceAnchorId == anchors[j].id) {
      //         lf.model.graphModel.edges[i].startPoint.x = anchors[j].x
      //         lf.model.graphModel.edges[i].startPoint.y = anchors[j].y
      //         break
      //       }
      //     }
      //   }
      // }

      // if (properties.radio == 'iframeUrl' && properties.iframeUrl && properties.iframeUrl != '' && properties.isShowTitle) {
      //   $("#iframeUrl-" + id).parent().css("background", "#FFFFFF")
      //   $("#iframeUrl-" + id).parent().css("box-shadow", "0px 2px 4px -1px rgba(0, 0, 0, 0.12), 0px 4px 5px 0px rgba(0, 0, 0, 0.08), 0px 1px 10px 0px rgba(0, 0, 0, 0.05)")
      //   lf.model.width = Math.round($("#iframeUrl_" + id).width())
      //   lf.model.height = properties.is_show_user ? 307 : 280
      //   if(lf.model.properties.nodeSize && lf.model.properties.nodeSize.width) {
      //     lf.model.properties.nodeSize.width = lf.model.width
      //   }
      //   if(lf.model.properties.nodeSize && lf.model.properties.nodeSize.height) {
      //     lf.model.properties.nodeSize.height = lf.model.height
      //   }
      //   let anchors = lf.model.anchors
      //   let edges = lf.model.graphModel.edges
      //   for (let i = 0; i < edges.length; i++) {
      //     for (let j = 0; j < anchors.length; j++) {
      //       if (edges[i].targetAnchorId == anchors[j].id) {
      //         lf.model.graphModel.edges[i].endPoint.x = anchors[j].x
      //         lf.model.graphModel.edges[i].endPoint.y = anchors[j].y
      //         break
      //       }
      //       if (edges[i].sourceAnchorId == anchors[j].id) {
      //         lf.model.graphModel.edges[i].startPoint.x = anchors[j].x
      //         lf.model.graphModel.edges[i].startPoint.y = anchors[j].y
      //         break
      //       }
      //     }
      //   }
      // }

      // if (properties.radio == 'iframeUrl' && properties.iframeUrl && properties.iframeUrl != '' && !properties.isShowTitle) {
      //   $("#iframeUrl-" + id).parent().css("background", "#FFFFFF")
      //   $("#iframeUrl-" + id).parent().css("box-shadow", "0px 2px 4px -1px rgba(0, 0, 0, 0.12), 0px 4px 5px 0px rgba(0, 0, 0, 0.08), 0px 1px 10px 0px rgba(0, 0, 0, 0.05)")
      //   lf.model.width = Math.round($("#iframeUrl_" + id).width())
      //   lf.model.height = properties.is_show_user ? 307 : 280
      //   if(lf.model.properties.nodeSize && lf.model.properties.nodeSize.width) {
      //     lf.model.properties.nodeSize.width = lf.model.width
      //   }
      //   if(lf.model.properties.nodeSize && lf.model.properties.nodeSize.height) {
      //     lf.model.properties.nodeSize.height = lf.model.height
      //   }
      //   let anchors = lf.model.anchors
      //   let edges = lf.model.graphModel.edges
      //   for (let i = 0; i < edges.length; i++) {
      //     for (let j = 0; j < anchors.length; j++) {
      //       if (edges[i].targetAnchorId == anchors[j].id) {
      //         lf.model.graphModel.edges[i].endPoint.x = anchors[j].x
      //         lf.model.graphModel.edges[i].endPoint.y = anchors[j].y
      //         break
      //       }
      //       if (edges[i].sourceAnchorId == anchors[j].id) {
      //         lf.model.graphModel.edges[i].startPoint.x = anchors[j].x
      //         lf.model.graphModel.edges[i].startPoint.y = anchors[j].y
      //         break
      //       }
      //     }
      //   }
      // }

      // if (properties.radio == 'imageList' && properties.imageList && properties.imageList.length != 0 && properties.isShowTitle) {
      //   $("#imageList_" + id).parent().css("box-shadow", "none")
      //   $("#imageList_" + id).parent().css("background", "none")
      //   lf.model.width = 250
      //   lf.model.height = properties.is_show_user ? 255 : 228
      //   if(lf.model.properties.nodeSize && lf.model.properties.nodeSize.width) {
      //     lf.model.properties.nodeSize.width = lf.model.width
      //   }
      //   if(lf.model.properties.nodeSize && lf.model.properties.nodeSize.height) {
      //     lf.model.properties.nodeSize.height = lf.model.height
      //   }
      //   let anchors = lf.model.anchors
      //   let edges = lf.model.graphModel.edges
      //   for (let i = 0; i < edges.length; i++) {
      //     for (let j = 0; j < anchors.length; j++) {
      //       if (edges[i].targetAnchorId == anchors[j].id) {
      //         lf.model.graphModel.edges[i].endPoint.x = anchors[j].x
      //         lf.model.graphModel.edges[i].endPoint.y = anchors[j].y
      //         break
      //       }
      //       if (edges[i].sourceAnchorId == anchors[j].id) {
      //         lf.model.graphModel.edges[i].startPoint.x = anchors[j].x
      //         lf.model.graphModel.edges[i].startPoint.y = anchors[j].y
      //         break
      //       }
      //     }
      //   }
      // }

      // if (properties.radio == 'imageList' && properties.imageList && properties.imageList.length != 0 && !properties.isShowTitle) {
      //   $("#imageList_" + id).parent().css("background", "#FFFFFF")
      //   $("#imageList_" + id).parent().css("box-shadow", "0px 2px 4px -1px rgba(0, 0, 0, 0.12), 0px 4px 5px 0px rgba(0, 0, 0, 0.08), 0px 1px 10px 0px rgba(0, 0, 0, 0.05)")
      //   lf.model.width = 250
      //   lf.model.height = properties.is_show_user ? 285 : 258
      //   if(lf.model.properties.nodeSize && lf.model.properties.nodeSize.width) {
      //     lf.model.properties.nodeSize.width = lf.model.width
      //   }
      //   if(lf.model.properties.nodeSize && lf.model.properties.nodeSize.height) {
      //     lf.model.properties.nodeSize.height = lf.model.height
      //   }
      //   let anchors = lf.model.anchors
      //   let edges = lf.model.graphModel.edges
      //   for (let i = 0; i < edges.length; i++) {
      //     for (let j = 0; j < anchors.length; j++) {
      //       if (edges[i].targetAnchorId == anchors[j].id) {
      //         lf.model.graphModel.edges[i].endPoint.x = anchors[j].x
      //         lf.model.graphModel.edges[i].endPoint.y = anchors[j].y
      //         break
      //       }
      //       if (edges[i].sourceAnchorId == anchors[j].id) {
      //         lf.model.graphModel.edges[i].startPoint.x = anchors[j].x
      //         lf.model.graphModel.edges[i].startPoint.y = anchors[j].y
      //         break
      //       }
      //     }
      //   }
      // }

      // if (properties.radio == 'videoList' && properties.videoList && properties.videoList.length != 0 && properties.isShowTitle) {
      //   $("#video-" + id).parent().css("box-shadow", "none")
      //   $("#video-" + id).parent().css("background", "none")
      //   lf.model.width = 250
      //   lf.model.height = properties.is_show_user ? 168 : 141
      //   if(lf.model.properties.nodeSize && lf.model.properties.nodeSize.width) {
      //     lf.model.properties.nodeSize.width = lf.model.width
      //   }
      //   if(lf.model.properties.nodeSize && lf.model.properties.nodeSize.height) {
      //     lf.model.properties.nodeSize.height = lf.model.height
      //   }
      //   let anchors = lf.model.anchors
      //   let edges = lf.model.graphModel.edges
      //   for (let i = 0; i < edges.length; i++) {
      //     for (let j = 0; j < anchors.length; j++) {
      //       if (edges[i].targetAnchorId == anchors[j].id) {
      //         lf.model.graphModel.edges[i].endPoint.x = anchors[j].x
      //         lf.model.graphModel.edges[i].endPoint.y = anchors[j].y
      //         break
      //       }
      //       if (edges[i].sourceAnchorId == anchors[j].id) {
      //         lf.model.graphModel.edges[i].startPoint.x = anchors[j].x
      //         lf.model.graphModel.edges[i].startPoint.y = anchors[j].y
      //         break
      //       }
      //     }
      //   }
      // }

      // if (properties.radio == 'videoList' && properties.videoList && properties.videoList.length != 0 && !properties.isShowTitle) {
      //   $("#video-" + id).parent().css("box-shadow", "none")
      //   $("#video-" + id).parent().css("background", "none")
      //   lf.model.width = 250
      //   lf.model.height = properties.is_show_user ? 198 : 171
      //   if(lf.model.properties.nodeSize && lf.model.properties.nodeSize.width) {
      //     lf.model.properties.nodeSize.width = lf.model.width
      //   }
      //   if(lf.model.properties.nodeSize && lf.model.properties.nodeSize.height) {
      //     lf.model.properties.nodeSize.height = lf.model.height
      //   }
      //   let anchors = lf.model.anchors
      //   let edges = lf.model.graphModel.edges
      //   for (let i = 0; i < edges.length; i++) {
      //     for (let j = 0; j < anchors.length; j++) {
      //       if (edges[i].targetAnchorId == anchors[j].id) {
      //         lf.model.graphModel.edges[i].endPoint.x = anchors[j].x
      //         lf.model.graphModel.edges[i].endPoint.y = anchors[j].y
      //         break
      //       }
      //       if (edges[i].sourceAnchorId == anchors[j].id) {
      //         lf.model.graphModel.edges[i].startPoint.x = anchors[j].x
      //         lf.model.graphModel.edges[i].startPoint.y = anchors[j].y
      //         break
      //       }
      //     }
      //   }
      // }

      // if (properties.radio == 'audioList' && properties.audioList && properties.audioList.length != 0 && properties.isShowTitle) {
      //   $("#audio-" + id).parent().css("background", "#FFFFFF")
      //   $("#audio-" + id).parent().css("box-shadow", "0px 2px 4px -1px rgba(0, 0, 0, 0.12), 0px 4px 5px 0px rgba(0, 0, 0, 0.08), 0px 1px 10px 0px rgba(0, 0, 0, 0.05)")
      //   lf.model.width = Math.round($("#audio_" + id).width())
      //   lf.model.height = properties.is_show_user ? 131 : 104
      //   if(lf.model.properties.nodeSize && lf.model.properties.nodeSize.width) {
      //     lf.model.properties.nodeSize.width = lf.model.width
      //   }
      //   if(lf.model.properties.nodeSize && lf.model.properties.nodeSize.height) {
      //     lf.model.properties.nodeSize.height = lf.model.height
      //   }
      //   let anchors = lf.model.anchors
      //   let edges = lf.model.graphModel.edges
      //   for (let i = 0; i < edges.length; i++) {
      //     for (let j = 0; j < anchors.length; j++) {
      //       if (edges[i].targetAnchorId == anchors[j].id) {
      //         lf.model.graphModel.edges[i].endPoint.x = anchors[j].x
      //         lf.model.graphModel.edges[i].endPoint.y = anchors[j].y
      //         break
      //       }
      //       if (edges[i].sourceAnchorId == anchors[j].id) {
      //         lf.model.graphModel.edges[i].startPoint.x = anchors[j].x
      //         lf.model.graphModel.edges[i].startPoint.y = anchors[j].y
      //         break
      //       }
      //     }
      //   }
      // }

      // if (properties.radio == 'audioList' && properties.audioList && properties.audioList.length != 0 && !properties.isShowTitle) {
      //   $("#audio-" + id).parent().css("background", "#FFFFFF")
      //   $("#audio-" + id).parent().css("box-shadow", "0px 2px 4px -1px rgba(0, 0, 0, 0.12), 0px 4px 5px 0px rgba(0, 0, 0, 0.08), 0px 1px 10px 0px rgba(0, 0, 0, 0.05)")
      //   lf.model.width = Math.round($("#audio_" + id).width())
      //   lf.model.height = properties.is_show_user ? 141 : 114
      //   if(lf.model.properties.nodeSize && lf.model.properties.nodeSize.width) {
      //     lf.model.properties.nodeSize.width = lf.model.width
      //   }
      //   if(lf.model.properties.nodeSize && lf.model.properties.nodeSize.height) {
      //     lf.model.properties.nodeSize.height = lf.model.height
      //   }
      //   let anchors = lf.model.anchors
      //   let edges = lf.model.graphModel.edges
      //   for (let i = 0; i < edges.length; i++) {
      //     for (let j = 0; j < anchors.length; j++) {
      //       if (edges[i].targetAnchorId == anchors[j].id) {
      //         lf.model.graphModel.edges[i].endPoint.x = anchors[j].x
      //         lf.model.graphModel.edges[i].endPoint.y = anchors[j].y
      //         break
      //       }
      //       if (edges[i].sourceAnchorId == anchors[j].id) {
      //         lf.model.graphModel.edges[i].startPoint.x = anchors[j].x
      //         lf.model.graphModel.edges[i].startPoint.y = anchors[j].y
      //         break
      //       }
      //     }
      //   }
      // }

      // if (properties.radio == 'fileList' && properties.fileList && properties.fileList.length != 0 && properties.isShowTitle) {
      //   $("#fileList-" + id).parent().css("background", "#FFFFFF")
      //   $("#fileList-" + id).parent().css("box-shadow", "0px 2px 4px -1px rgba(0, 0, 0, 0.12), 0px 4px 5px 0px rgba(0, 0, 0, 0.08), 0px 1px 10px 0px rgba(0, 0, 0, 0.05)")
      //   lf.model.width = Math.round($("#file_" + id).width())
      //   lf.model.height = properties.is_show_user ? 307 : 280
      //   if(lf.model.properties.nodeSize && lf.model.properties.nodeSize.width) {
      //     lf.model.properties.nodeSize.width = lf.model.width
      //   }
      //   if(lf.model.properties.nodeSize && lf.model.properties.nodeSize.height) {
      //     lf.model.properties.nodeSize.height = lf.model.height
      //   }
      //   let anchors = lf.model.anchors
      //   let edges = lf.model.graphModel.edges
      //   for (let i = 0; i < edges.length; i++) {
      //     for (let j = 0; j < anchors.length; j++) {
      //       if (edges[i].targetAnchorId == anchors[j].id) {
      //         lf.model.graphModel.edges[i].endPoint.x = anchors[j].x
      //         lf.model.graphModel.edges[i].endPoint.y = anchors[j].y
      //         break
      //       }
      //       if (edges[i].sourceAnchorId == anchors[j].id) {
      //         lf.model.graphModel.edges[i].startPoint.x = anchors[j].x
      //         lf.model.graphModel.edges[i].startPoint.y = anchors[j].y
      //         break
      //       }
      //     }
      //   }
      // }

      // if (properties.radio == 'fileList' && properties.fileList && properties.fileList.length != 0 && !properties.isShowTitle) {
      //   $("#fileList-" + id).parent().css("background", "#FFFFFF")
      //   $("#fileList-" + id).parent().css("box-shadow", "0px 2px 4px -1px rgba(0, 0, 0, 0.12), 0px 4px 5px 0px rgba(0, 0, 0, 0.08), 0px 1px 10px 0px rgba(0, 0, 0, 0.05)")
      //   lf.model.width = Math.round($("#file_" + id).width())
      //   lf.model.height = 277
      //   if(lf.model.properties.nodeSize && lf.model.properties.nodeSize.width) {
      //     lf.model.properties.nodeSize.width = lf.model.width
      //   }
      //   if(lf.model.properties.nodeSize && lf.model.properties.nodeSize.height) {
      //     lf.model.properties.nodeSize.height = lf.model.height
      //   }
      //   let anchors = lf.model.anchors
      //   let edges = lf.model.graphModel.edges
      //   for (let i = 0; i < edges.length; i++) {
      //     for (let j = 0; j < anchors.length; j++) {
      //       if (edges[i].targetAnchorId == anchors[j].id) {
      //         lf.model.graphModel.edges[i].endPoint.x = anchors[j].x
      //         lf.model.graphModel.edges[i].endPoint.y = anchors[j].y
      //         break
      //       }
      //       if (edges[i].sourceAnchorId == anchors[j].id) {
      //         lf.model.graphModel.edges[i].startPoint.x = anchors[j].x
      //         lf.model.graphModel.edges[i].startPoint.y = anchors[j].y
      //         break
      //       }
      //     }
      //   }
      // }

      // if (properties.radio == 'content' && properties.content && properties.content != '') {
      //   let fontsize = $('.uml-body').css('font-size');
      //   if (fontsize == "12px") {
      //     $(".uml-body p").css({
      //       "-webkit-transform": "scale(0.83)"
      //     })
      //   }
      // }

      // if (properties.radio == 'videoList' && properties.videoList && properties.videoList.length != 0 && properties.styleRadio == "2") {
      //   console.log("#video-" + id)
      //   console.log($("#video-" + id))
      //   if($("#video-" + id)) {
      //     console.log($("#video-" + id + " div").outerHeight(true))
      //   }
      // }

      // if (properties.describe) {
      //   const textTips = properties.describe ? properties.describe : '';
      //   //添加自定义属性 target-title
      //   //itemContainer表示，需要在哪个DOM下增加title（自定义属性）
      //   el.setAttribute("target-title", textTips);
      //   //判断这个DOM节点是否包含这个自定义属性，
      //   if (el.getAttributeNode("target-title")) {
      //     //有的话直接调用函数。（用于多个相同DOM命名，统一添加，）
      //     const textTips = el.getAttribute('target-title');
      //     //如果用的地方比较少，不需要多个添加，可以直接调用函数
      //     //itemContainer 表示，需要在哪个DOM下增加title
      //     //textTips  需要展示的title文本
      //     this.contentTitle(el, textTips, this.props, properties.isShowDescribe);
      //   }
      // }
    }
  }
}

export default {
  type: "icon-card",
  view: CardNode,
  model: CardModel,
};
